import type {
  Resolver as GraphCacheResolver,
  UpdateResolver as GraphCacheUpdateResolver,
  OptimisticMutationResolver as GraphCacheOptimisticMutationResolver,
  StorageAdapter as GraphCacheStorageAdapter,
} from '@urql/exchange-graphcache';
import type { IntrospectionData } from '@urql/exchange-graphcache/dist/types/ast';
import { gql } from 'urql';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A valid absolute URL string starting with either a valid protocol or a leading www */
  AbsoluteUrl: any;
  /** A country code as defined by ISO 3166-1 alpha-2 */
  CountryCode: any;
  /** The `DateTime` scalar type represents Strings that are expected to be in ISO 8601 format (YYYY-MM-DDTHH:mm:ssZ) */
  DateTime: any;
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: any;
  /** String that might contain sanitized HTML. */
  HTMLString: any;
  /** A field whose value is a hex color code: https://en.wikipedia.org/wiki/Web_colors. */
  HexColorCode: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: Record<string, unknown>;
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: any;
  /** Integers that will have a value of 0 or more. */
  UnsignedInt: any;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  postal_code: Scalars['String'];
  state: Scalars['String'];
};

export type AddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  postal_code: Scalars['String'];
  state: Scalars['String'];
};

export type AddressParent = {
  __typename?: 'AddressParent';
  address: Address;
  name: Scalars['String'];
  phone: Scalars['PhoneNumber'];
};

export type AddressParentInput = {
  address: AddressInput;
  name: Scalars['String'];
  phone: Scalars['PhoneNumber'];
};

export type AnonymizedAddress = {
  __typename?: 'AnonymizedAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  state: Scalars['String'];
};

export type AnonymizedAddressParent = {
  __typename?: 'AnonymizedAddressParent';
  address: AnonymizedAddress;
};

export type AuthCredential = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Basket = {
  __typename?: 'Basket';
  billing_address?: Maybe<AddressParent>;
  cart_id: Scalars['String'];
  created_at: Scalars['DateTime'];
  email?: Maybe<Scalars['EmailAddress']>;
  /** External URL to complete the checkout */
  external_url?: Maybe<Scalars['AbsoluteUrl']>;
  id: Scalars['ID'];
  items: Array<BasketItem>;
  order?: Maybe<BasketOrder>;
  payment_method?: Maybe<BasketPaymentMethod>;
  shipping_address?: Maybe<AddressParent>;
  shipping_cost?: Maybe<Price>;
  shipping_method_id?: Maybe<Scalars['ID']>;
  status?: Maybe<BasketStatus>;
  subtotal: Price;
  taxes: Array<BasketTaxes>;
  total?: Maybe<Price>;
  transaction?: Maybe<BasketTransaction>;
  updated_at: Scalars['DateTime'];
};

export type BasketAddPaymentMethodInput = {
  id: Scalars['ID'];
  /** This is returned by Spreedly's iFrame in exchange for a credit card number, expiration and cvv. */
  payment_method_token: Scalars['ID'];
};

export type BasketAnonymized = {
  __typename?: 'BasketAnonymized';
  cart_user_id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  items: Array<BasketItem>;
  origin?: Maybe<Scalars['String']>;
  shipping_address?: Maybe<AnonymizedAddressParent>;
  shipping_cost?: Maybe<Price>;
  subtotal: Price;
  taxes: Array<BasketTaxes>;
  total?: Maybe<Price>;
};

export type BasketAnonymizedConnection = {
  __typename?: 'BasketAnonymizedConnection';
  edges?: Maybe<Array<Maybe<BasketAnonymizedEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BasketAnonymizedEdge = {
  __typename?: 'BasketAnonymizedEdge';
  cursor: Scalars['String'];
  node?: Maybe<BasketAnonymized>;
};

export type BasketCreateInput = {
  cart_id: Scalars['ID'];
  discounts_applied?: InputMaybe<Scalars['Boolean']>;
  items: Array<BasketItemsInput>;
  origin?: InputMaybe<Scalars['String']>;
};

export type BasketFinalizeInput = {
  id: Scalars['ID'];
};

export type BasketItem = {
  __typename?: 'BasketItem';
  price: Price;
  quantity: Scalars['Int'];
  sku: Scalars['ID'];
};

export type BasketItemsInput = {
  quantity: Scalars['Int'];
  sku: Scalars['ID'];
};

export type BasketOrder = {
  __typename?: 'BasketOrder';
  id: Scalars['ID'];
};

export type BasketPaymentMethod = {
  __typename?: 'BasketPaymentMethod';
  card_type: Scalars['String'];
  full_name: Scalars['String'];
  last_four_digits: Scalars['String'];
  month: Scalars['Int'];
  token: Scalars['String'];
  year: Scalars['Int'];
};

export type BasketPrepareOrderInput = {
  browser_info?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  /** If there's a payment token, send it. */
  payment_method_token?: InputMaybe<Scalars['String']>;
};

export type BasketShippingMethod = {
  __typename?: 'BasketShippingMethod';
  id: Scalars['ID'];
  is_default: Scalars['Boolean'];
  name: Scalars['String'];
  price: Price;
};

export enum BasketStatus {
  PaymentAuthorizationFailed = 'PAYMENT_AUTHORIZATION_FAILED',
  PaymentAuthorizationSuccessful = 'PAYMENT_AUTHORIZATION_SUCCESSFUL',
  Pending = 'PENDING',
}

export type BasketTaxes = {
  __typename?: 'BasketTaxes';
  code: Scalars['String'];
  name: Scalars['String'];
  price: Price;
};

export type BasketTransaction = {
  __typename?: 'BasketTransaction';
  state: Scalars['String'];
};

export type BasketUpdateInput = {
  billing_address?: InputMaybe<AddressParentInput>;
  email?: InputMaybe<Scalars['EmailAddress']>;
  id: Scalars['ID'];
  items?: InputMaybe<Array<BasketItemsInput>>;
  shipping_address?: InputMaybe<AddressParentInput>;
  shipping_method_id?: InputMaybe<Scalars['ID']>;
};

export type CampaignSubscribe = {
  __typename?: 'CampaignSubscribe';
  body: Scalars['String'];
  campaign_id: Scalars['ID'];
  phone_number: Scalars['PhoneNumber'];
};

export type Cart = {
  __typename?: 'Cart';
  catalog_id?: Maybe<Scalars['String']>;
  collection_id?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  creator: Creator;
  creator_id: Scalars['String'];
  discount_applied_template?: Maybe<Scalars['String']>;
  discount_code?: Maybe<Scalars['String']>;
  discount_message_template?: Maybe<Scalars['String']>;
  discount_percentage?: Maybe<Scalars['Float']>;
  /** @deprecated use CartAnalytics query */
  gross_sales: Scalars['Int'];
  id: Scalars['ID'];
  popup_discounts?: Maybe<Scalars['Boolean']>;
  popup_timeout?: Maybe<Scalars['Int']>;
  products: Array<Product>;
  products_overrides?: Maybe<Scalars['JSON']>;
  promo_message?: Maybe<Scalars['String']>;
  requires_auth: Scalars['Boolean'];
  shop?: Maybe<Shop>;
  slug: Scalars['String'];
  tax_shipping_label?: Maybe<Scalars['String']>;
  testimonial?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
  whitelist_products?: Maybe<Scalars['JSON']>;
};

export type CartConnection = {
  __typename?: 'CartConnection';
  edges?: Maybe<Array<Maybe<CartEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CartEdge = {
  __typename?: 'CartEdge';
  cursor: Scalars['String'];
  node?: Maybe<Cart>;
};

export type CartRefreshInput = {
  cart_id: Scalars['ID'];
};

export type CartSalesRow = {
  __typename?: 'CartSalesRow';
  amount: Scalars['Int'];
  count: Scalars['Int'];
  date: Scalars['DateTime'];
};

export type CartSubscribe = {
  __typename?: 'CartSubscribe';
  body: Scalars['String'];
  phone_number: Scalars['PhoneNumber'];
};

export type CartUpsertInput = {
  catalog_id: Scalars['ID'];
  collection_id: Scalars['ID'];
  creator_id: Scalars['ID'];
  /** If this is filled, we'll apply a discount code automatically */
  discount_code?: InputMaybe<Scalars['String']>;
  /** If this is filled, we'll display the items with a discounted price */
  discount_percentage?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  popup_discounts?: InputMaybe<Scalars['Boolean']>;
  popup_timeout?: InputMaybe<Scalars['Int']>;
  /** Allow overriding of a specific product */
  products_overrides?: InputMaybe<Array<ProductOverrideInput>>;
  promo_message?: InputMaybe<Scalars['String']>;
  shop_id: Scalars['ID'];
  slug: Scalars['String'];
  tax_shipping_label?: InputMaybe<Scalars['String']>;
  testimonial?: InputMaybe<Scalars['String']>;
  theme?: InputMaybe<Scalars['String']>;
  /** Whitelisted products. If this is empty, it'll add every products in the collection. */
  whitelist_products?: InputMaybe<Array<Scalars['ID']>>;
};

export type CartUserCurrent = {
  __typename?: 'CartUserCurrent';
  id: Scalars['ID'];
  phone_number: Scalars['PhoneNumber'];
};

export type ChartRow = {
  __typename?: 'ChartRow';
  count: Scalars['Int'];
  date: Scalars['DateTime'];
};

export type ConversionInput = {
  action: Scalars['String'];
  campaign: Scalars['ID'];
  ip?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  productLink?: InputMaybe<Scalars['String']>;
  referrer?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
};

export type Creator = {
  __typename?: 'Creator';
  address_id?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['AbsoluteUrl']>;
  created_at: Scalars['DateTime'];
  default_cart_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_approved?: Maybe<Scalars['Boolean']>;
  phone_number?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  socials: Array<SocialLink>;
  /** @deprecated use CreatortAnalytics query */
  subscribers?: Maybe<SubscriberConnection>;
  updated_at: Scalars['DateTime'];
  user_id?: Maybe<Scalars['String']>;
};

export type CreatorSubscribersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CreatorAcceptInviteInput = {
  id: Scalars['ID'];
};

export type CreatorAnalytics = {
  __typename?: 'CreatorAnalytics';
  carts?: Maybe<CartConnection>;
  carts_analytics?: Maybe<CreatorCartAnalyticsConnection>;
  charts_sales_failure: Array<CartSalesRow>;
  charts_sales_pending: Array<CartSalesRow>;
  charts_sales_success: Array<CartSalesRow>;
  charts_subscriptions: Array<ChartRow>;
  charts_unsubscriptions: Array<ChartRow>;
  creator: Creator;
  gross_sales: Price;
  sales_failure?: Maybe<BasketAnonymizedConnection>;
  sales_pending?: Maybe<BasketAnonymizedConnection>;
  sales_success?: Maybe<BasketAnonymizedConnection>;
  shops?: Maybe<ShopConnection>;
  shops_analytics?: Maybe<ShopCreatorAnalyticsConnection>;
  total_subscriptions: Scalars['Int'];
  total_unsubscriptions: Scalars['Int'];
};

export type CreatorAnalyticsCartsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CreatorAnalyticsCarts_AnalyticsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CreatorAnalyticsSales_FailureArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CreatorAnalyticsSales_PendingArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CreatorAnalyticsSales_SuccessArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CreatorAnalyticsShopsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CreatorAnalyticsShops_AnalyticsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CreatorApproveUserProfileInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type CreatorCartAnalytics = {
  __typename?: 'CreatorCartAnalytics';
  cart: Cart;
  creator: Creator;
  gross_sales: Price;
  sales_success?: Maybe<BasketAnonymizedConnection>;
};

export type CreatorCartAnalyticsSales_SuccessArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CreatorCartAnalyticsConnection = {
  __typename?: 'CreatorCartAnalyticsConnection';
  edges?: Maybe<Array<Maybe<CreatorCartAnalyticsEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CreatorCartAnalyticsEdge = {
  __typename?: 'CreatorCartAnalyticsEdge';
  cursor: Scalars['String'];
  node?: Maybe<CreatorCartAnalytics>;
};

export type CreatorConnection = {
  __typename?: 'CreatorConnection';
  edges?: Maybe<Array<Maybe<CreatorEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CreatorEdge = {
  __typename?: 'CreatorEdge';
  cursor: Scalars['String'];
  node?: Maybe<Creator>;
};

export type CreatorInput = {
  email: Scalars['EmailAddress'];
  name?: InputMaybe<Scalars['String']>;
};

export type CreatorProfileUpsertInput = {
  address?: InputMaybe<Scalars['String']>;
  avatar: Scalars['AbsoluteUrl'];
  id?: InputMaybe<Scalars['ID']>;
  slug: Scalars['String'];
  socials: Array<SocialLinkInput>;
};

export type Geolocation = {
  __typename?: 'Geolocation';
  calling_code: Scalars['String'];
  city: Scalars['String'];
  country_code: Scalars['CountryCode'];
};

export type Image = {
  __typename?: 'Image';
  alt?: Maybe<Scalars['String']>;
  url: Scalars['AbsoluteUrl'];
};

export enum ImageExtension {
  Jpeg = 'jpeg',
  Jpg = 'jpg',
  Png = 'png',
}

export enum ImageResourceType {
  Creator = 'creator',
  Shop = 'shop',
  Template = 'template',
}

export type ImageUploadInput = {
  extension: ImageExtension;
  node_id: Scalars['ID'];
  resource_type: ImageResourceType;
};

export type ImageUploadOutput = {
  __typename?: 'ImageUploadOutput';
  signed_url: Scalars['AbsoluteUrl'];
  url: Scalars['AbsoluteUrl'];
};

export type Invoice = {
  __typename?: 'Invoice';
  basket: Basket;
  cart: Cart;
};

export type LiteAnalytics = {
  __typename?: 'LiteAnalytics';
  metrics: LiteAnalyticsMetrics;
  productLinkStats?: Maybe<Array<LiteProductLinkStats>>;
  subscriptions?: Maybe<Array<Scalars['String']>>;
};

export type LiteAnalyticsMetrics = {
  __typename?: 'LiteAnalyticsMetrics';
  campaigns?: Maybe<Scalars['String']>;
  productLinkVisits?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<Scalars['String']>;
  visits?: Maybe<Scalars['String']>;
};

export type LiteCampaign = {
  __typename?: 'LiteCampaign';
  creator: Creator;
  creator_id: Scalars['String'];
  id: Scalars['ID'];
  links?: Maybe<Array<Maybe<ProductLink>>>;
  shop_id: Scalars['String'];
  slug: Scalars['String'];
};

export type LiteCampaignConnection = {
  __typename?: 'LiteCampaignConnection';
  edges?: Maybe<Array<Maybe<LiteCampaignEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type LiteCampaignEdge = {
  __typename?: 'LiteCampaignEdge';
  cursor: Scalars['String'];
  node?: Maybe<LiteCampaign>;
};

export type LiteCampaignUpsertInput = {
  creator_id: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  links?: InputMaybe<Array<InputMaybe<ProductLinkInput>>>;
  shop_id: Scalars['String'];
  slug: Scalars['String'];
};

export type LiteConversion = {
  __typename?: 'LiteConversion';
  action: Scalars['String'];
  campaign: Scalars['ID'];
  ip?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  referrer?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
};

export type LiteProductLinkStats = {
  __typename?: 'LiteProductLinkStats';
  slug?: Maybe<Scalars['String']>;
  visits?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Adding a payment method is its own mutation */
  BasketAddPaymentMethod: Basket;
  /** Creates a new basket. This call will return an ID which you need to include in every other request */
  BasketCreate: Basket;
  /** After the payment is authorized (3ds or not), we need to call this to finalize the payment. */
  BasketFinalize?: Maybe<Basket>;
  /** This is the call when we're ready to authorize the payment. */
  BasketPrepareOrder: Basket;
  /** The bulk of the logic is here, to update items, shipping addresses, etc. */
  BasketUpdate: Basket;
  /** Refreshes the cart catalog and prices */
  CartRefresh: Cart;
  CartUpsert: Cart;
  ConversionTrack: LiteConversion;
  CreatorAcceptInvite: Creator;
  CreatorApproveUserProfile: Creator;
  CreatorProfileUpsert: Creator;
  ImageUpload: ImageUploadOutput;
  LiteCampaignUpsert: LiteCampaign;
  PhoneNumberReserve: Creator;
  ReservationAdd: Reservation;
  ShopAddPaymentProvider: Shop;
  /** Create a Shopify store using a storefront access token */
  ShopCreateSFCC: Shop;
  /** Create a Shopify store using OAuth */
  ShopCreateShopify: ShopCreateShopifyOutput;
  /** Create a Shopify store using a storefront access token */
  ShopCreateShopifyNative: Shop;
  ShopEdit: Shop;
  /** Invite a creator to a shop */
  ShopInviteCreator: Shop;
  ShopRemovePaymentProvider: Shop;
  TemplateDelete: TemplateDeleteOutput;
  TemplateUpsert: Template;
  UserUpdate: UserFull;
  VideoUpload: VideoUploadOutput;
};

export type MutationBasketAddPaymentMethodArgs = {
  input: BasketAddPaymentMethodInput;
};

export type MutationBasketCreateArgs = {
  input: BasketCreateInput;
};

export type MutationBasketFinalizeArgs = {
  input: BasketFinalizeInput;
};

export type MutationBasketPrepareOrderArgs = {
  input: BasketPrepareOrderInput;
};

export type MutationBasketUpdateArgs = {
  input: BasketUpdateInput;
};

export type MutationCartRefreshArgs = {
  input: CartRefreshInput;
};

export type MutationCartUpsertArgs = {
  input: CartUpsertInput;
};

export type MutationConversionTrackArgs = {
  input: ConversionInput;
};

export type MutationCreatorAcceptInviteArgs = {
  input: CreatorAcceptInviteInput;
};

export type MutationCreatorApproveUserProfileArgs = {
  input: CreatorApproveUserProfileInput;
};

export type MutationCreatorProfileUpsertArgs = {
  input: CreatorProfileUpsertInput;
};

export type MutationImageUploadArgs = {
  input: ImageUploadInput;
};

export type MutationLiteCampaignUpsertArgs = {
  input: LiteCampaignUpsertInput;
};

export type MutationPhoneNumberReserveArgs = {
  input: PhoneNumberReserveInput;
};

export type MutationReservationAddArgs = {
  input: ReservationAddInput;
};

export type MutationShopAddPaymentProviderArgs = {
  input: ShopAddPaymentProviderInput;
};

export type MutationShopCreateSfccArgs = {
  input: ShopCreateSfccInput;
};

export type MutationShopCreateShopifyArgs = {
  input: ShopCreateShopifyInput;
};

export type MutationShopCreateShopifyNativeArgs = {
  input: ShopCreateShopifyNativeInput;
};

export type MutationShopEditArgs = {
  input: ShopEditInput;
};

export type MutationShopInviteCreatorArgs = {
  input: ShopInviteCreatorInput;
};

export type MutationShopRemovePaymentProviderArgs = {
  input: ShopRemovePaymentProviderInput;
};

export type MutationTemplateDeleteArgs = {
  id: Scalars['ID'];
};

export type MutationTemplateUpsertArgs = {
  input: TemplateUpsertInput;
};

export type MutationUserUpdateArgs = {
  input: UpdateUserInput;
};

export type MutationVideoUploadArgs = {
  input: VideoUploadInput;
};

export type Node = {
  id: Scalars['ID'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

/** This type is returned by Spreedly. We use it to create a PaymentProvider */
export type PaymentGateway = {
  __typename?: 'PaymentGateway';
  auth_modes: Array<PaymentGatewayAuthMode>;
  gateway_type: Scalars['String'];
  name: Scalars['String'];
  payment_methods: Array<Scalars['String']>;
  supported_countries: Array<Scalars['CountryCode']>;
};

export type PaymentGatewayAuthMode = {
  __typename?: 'PaymentGatewayAuthMode';
  auth_mode_type: Scalars['String'];
  credentials: Array<PaymentGatewayCredential>;
  name: Scalars['String'];
};

export type PaymentGatewayCredential = {
  __typename?: 'PaymentGatewayCredential';
  label: Scalars['String'];
  name: Scalars['String'];
  safe: Scalars['Boolean'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  billing_details?: Maybe<PaymentMethodBillingDetails>;
  card: PaymentMethodCard;
  id: Scalars['ID'];
  type?: Maybe<Scalars['String']>;
};

export type PaymentMethodBillingDetails = {
  __typename?: 'PaymentMethodBillingDetails';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['EmailAddress']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['PhoneNumber']>;
};

export type PaymentMethodCard = {
  __typename?: 'PaymentMethodCard';
  brand: Scalars['String'];
  country: Scalars['String'];
  exp_month: Scalars['Int'];
  exp_year: Scalars['Int'];
  last4: Scalars['String'];
};

/** This type is used once a payment gateway has been created */
export type PaymentProvider = {
  __typename?: 'PaymentProvider';
  accepted_card_brands: Array<Scalars['String']>;
  config?: Maybe<PaymentProviderConfig>;
  gateway_type?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type PaymentProviderConfig = PaymentProviderShopifyConfig | PaymentProviderSpreedlyConfig;

export type PaymentProviderShopifyConfig = {
  __typename?: 'PaymentProviderShopifyConfig';
  card_vault_url: Scalars['String'];
  shopify_payments_account_id: Scalars['String'];
};

export type PaymentProviderSpreedlyConfig = {
  __typename?: 'PaymentProviderSpreedlyConfig';
  enable_3ds: Scalars['Boolean'];
  environment_key: Scalars['String'];
  gateway_token: Scalars['String'];
  sandbox?: Maybe<Scalars['String']>;
};

export type PhoneNumberDetails = {
  __typename?: 'PhoneNumberDetails';
  country: Scalars['CountryCode'];
  phone_number: Scalars['PhoneNumber'];
  region?: Maybe<Scalars['String']>;
};

export type PhoneNumberReserveInput = {
  address_sid?: InputMaybe<Scalars['String']>;
  creator_id: Scalars['ID'];
  phone_number: Scalars['PhoneNumber'];
};

export type PhoneNumbersAvailableInput = {
  area_code?: InputMaybe<Scalars['Int']>;
  country_code: Scalars['CountryCode'];
};

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Int'];
  currency: Scalars['String'];
  old_amount?: Maybe<Scalars['Int']>;
};

export type Product = {
  __typename?: 'Product';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images: Array<Image>;
  name: Scalars['String'];
  options: Array<ProductOption>;
  variants: Array<ProductVariant>;
};

export type ProductCatalog = {
  __typename?: 'ProductCatalog';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type ProductCatalogConnection = {
  __typename?: 'ProductCatalogConnection';
  edges?: Maybe<Array<Maybe<ProductCatalogEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductCatalogEdge = {
  __typename?: 'ProductCatalogEdge';
  cursor: Scalars['String'];
  node?: Maybe<ProductCatalog>;
};

export type ProductCollection = {
  __typename?: 'ProductCollection';
  catalog_id?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type ProductCollectionConnection = {
  __typename?: 'ProductCollectionConnection';
  edges?: Maybe<Array<Maybe<ProductCollectionEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductCollectionEdge = {
  __typename?: 'ProductCollectionEdge';
  cursor: Scalars['String'];
  node?: Maybe<ProductCollection>;
};

export type ProductConnection = {
  __typename?: 'ProductConnection';
  edges?: Maybe<Array<Maybe<ProductEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductEdge = {
  __typename?: 'ProductEdge';
  cursor: Scalars['String'];
  node?: Maybe<Product>;
};

export type ProductLink = {
  __typename?: 'ProductLink';
  link: Scalars['String'];
  slug: Scalars['String'];
};

export type ProductLinkInput = {
  link: Scalars['String'];
  slug: Scalars['String'];
};

export type ProductOption = {
  __typename?: 'ProductOption';
  choices: Array<ProductOptionChoice>;
  label: Scalars['String'];
  type: ProductOptionType;
  value: Scalars['String'];
};

export type ProductOptionChoice = {
  __typename?: 'ProductOptionChoice';
  image?: Maybe<Image>;
  label: Scalars['String'];
  value: Scalars['String'];
};

export enum ProductOptionType {
  Dropdown = 'dropdown',
  ImageSwatch = 'image_swatch',
}

export type ProductOverride = {
  __typename?: 'ProductOverride';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  /** No decimals amount. 30$ = 3000 */
  price_amount?: Maybe<Scalars['Int']>;
};

export type ProductOverrideInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  /** No decimals amount. 30$ = 3000 */
  price_amount?: InputMaybe<Scalars['Int']>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images: Array<Image>;
  name: Scalars['String'];
  price: Price;
  prices: Array<Price>;
  sku: Scalars['String'];
  soldOut?: Maybe<Scalars['Boolean']>;
  variations: Scalars['JSONObject'];
};

export type ProductVariantPriceArgs = {
  currency: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  Basket: Basket;
  BasketShippingMethods: Array<BasketShippingMethod>;
  CampaignSubscribe?: Maybe<CampaignSubscribe>;
  Cart: Cart;
  CartById: Cart;
  CartSubscribe: CartSubscribe;
  CartUserCurrent?: Maybe<CartUserCurrent>;
  Carts?: Maybe<CartConnection>;
  Conversions?: Maybe<Array<Maybe<LiteConversion>>>;
  Creator: Creator;
  CreatorAnalytics: CreatorAnalytics;
  CreatorWithSlug: Creator;
  Creators?: Maybe<CreatorConnection>;
  Geolocation: Geolocation;
  Invoice: Invoice;
  LiteCampaign: LiteCampaign;
  LiteCampaignWithSlug: LiteCampaign;
  LiteCampaigns?: Maybe<LiteCampaignConnection>;
  LiteCampaignsAnalytics?: Maybe<LiteAnalytics>;
  Node?: Maybe<Node>;
  PaymentGatewaysList: Array<PaymentGateway>;
  PhoneNumbersAvailable: Array<PhoneNumberDetails>;
  Shop: Shop;
  ShopAnalytics: ShopAnalytics;
  Shops?: Maybe<ShopConnection>;
  /** @deprecated we should delete this */
  Subscribers?: Maybe<SubscriberConnection>;
  /** @deprecated we should delete this */
  SubscribersChart: Array<SubscriberChartRow>;
  Template: Template;
  Templates?: Maybe<TemplateConnection>;
  User: UserAnonymized;
  UserCurrent?: Maybe<UserCurrent>;
  UserFull: UserFull;
  Users?: Maybe<UserAnonymizedConnection>;
  UsersList?: Maybe<UserFullConnection>;
};

export type QueryBasketArgs = {
  id: Scalars['ID'];
};

export type QueryBasketShippingMethodsArgs = {
  id: Scalars['ID'];
};

export type QueryCampaignSubscribeArgs = {
  creator_slug: Scalars['String'];
  slug: Scalars['String'];
};

export type QueryCartArgs = {
  creator_slug: Scalars['String'];
  slug?: InputMaybe<Scalars['String']>;
};

export type QueryCartByIdArgs = {
  id: Scalars['ID'];
};

export type QueryCartSubscribeArgs = {
  creator_slug: Scalars['String'];
  slug?: InputMaybe<Scalars['String']>;
};

export type QueryCartsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryCreatorArgs = {
  id: Scalars['ID'];
};

export type QueryCreatorAnalyticsArgs = {
  id: Scalars['ID'];
};

export type QueryCreatorWithSlugArgs = {
  slug: Scalars['String'];
};

export type QueryCreatorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryInvoiceArgs = {
  basket_id: Scalars['ID'];
  payment_intent_id: Scalars['ID'];
};

export type QueryLiteCampaignArgs = {
  id: Scalars['ID'];
};

export type QueryLiteCampaignWithSlugArgs = {
  creator_slug: Scalars['String'];
  slug: Scalars['String'];
};

export type QueryLiteCampaignsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryLiteCampaignsAnalyticsArgs = {
  shop_id?: InputMaybe<Scalars['String']>;
};

export type QueryNodeArgs = {
  id: Scalars['ID'];
};

export type QueryPhoneNumbersAvailableArgs = {
  input: PhoneNumbersAvailableInput;
};

export type QueryShopArgs = {
  id: Scalars['ID'];
};

export type QueryShopAnalyticsArgs = {
  id: Scalars['ID'];
};

export type QueryShopsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QuerySubscribersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  creator_id: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QuerySubscribersChartArgs = {
  creator_id: Scalars['ID'];
};

export type QueryTemplateArgs = {
  id: Scalars['ID'];
};

export type QueryTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cart_id: Scalars['ID'];
  creator_id: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryUserArgs = {
  id: Scalars['ID'];
};

export type QueryUserFullArgs = {
  id: Scalars['ID'];
};

export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type QueryUsersListArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type Reservation = {
  __typename?: 'Reservation';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  phone_number: Scalars['String'];
  slug: Scalars['String'];
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type ReservationAddInput = {
  phone_number: Scalars['PhoneNumber'];
  slug: Scalars['String'];
};

export enum Role {
  Guest = 'GUEST',
  Owner = 'OWNER',
  User = 'USER',
}

export type Shop = {
  avatar?: Maybe<Scalars['AbsoluteUrl']>;
  carts?: Maybe<CartConnection>;
  catalogs?: Maybe<ProductCatalogConnection>;
  collections?: Maybe<ProductCollectionConnection>;
  created_at: Scalars['DateTime'];
  creators?: Maybe<CreatorConnection>;
  default_country_code?: Maybe<Scalars['String']>;
  default_currency?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  production_date?: Maybe<Scalars['DateTime']>;
  products?: Maybe<ProductConnection>;
  provider: ShopProvider;
  updated_at: Scalars['DateTime'];
};

export type ShopCartsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopCatalogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalog_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopCreatorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalog_id?: InputMaybe<Scalars['ID']>;
  collection_id: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopAddPaymentProviderInput = {
  auth_credentials: Array<AuthCredential>;
  auth_mode_type: Scalars['String'];
  gateway_type: Scalars['String'];
  sandbox?: InputMaybe<Scalars['Boolean']>;
  shop_id: Scalars['ID'];
};

export type ShopAnalytics = {
  __typename?: 'ShopAnalytics';
  carts?: Maybe<CartConnection>;
  carts_analytics?: Maybe<ShopCartAnalyticsConnection>;
  charts_sales_failure: Array<CartSalesRow>;
  charts_sales_pending: Array<CartSalesRow>;
  charts_sales_success: Array<CartSalesRow>;
  charts_subscriptions: Array<ChartRow>;
  charts_unsubscriptions: Array<ChartRow>;
  creators?: Maybe<CreatorConnection>;
  creators_analytics?: Maybe<ShopCreatorAnalyticsConnection>;
  gross_sales: Price;
  sales_failure?: Maybe<BasketAnonymizedConnection>;
  sales_pending?: Maybe<BasketAnonymizedConnection>;
  sales_success?: Maybe<BasketAnonymizedConnection>;
  shop: Shop;
  total_creators_subscriptions: Scalars['Int'];
  total_creators_unsubscriptions: Scalars['Int'];
};

export type ShopAnalyticsCartsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopAnalyticsCarts_AnalyticsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopAnalyticsCreatorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopAnalyticsCreators_AnalyticsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopAnalyticsSales_FailureArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopAnalyticsSales_PendingArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopAnalyticsSales_SuccessArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopBrand = Node &
  Shop & {
    __typename?: 'ShopBrand';
    avatar?: Maybe<Scalars['AbsoluteUrl']>;
    carts?: Maybe<CartConnection>;
    catalogs?: Maybe<ProductCatalogConnection>;
    collections?: Maybe<ProductCollectionConnection>;
    created_at: Scalars['DateTime'];
    creators?: Maybe<CreatorConnection>;
    default_country_code?: Maybe<Scalars['String']>;
    default_currency?: Maybe<Scalars['String']>;
    display_name?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    production_date?: Maybe<Scalars['DateTime']>;
    products?: Maybe<ProductConnection>;
    provider: ShopProvider;
    updated_at: Scalars['DateTime'];
  };

export type ShopBrandCartsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopBrandCatalogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopBrandCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalog_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopBrandCreatorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopBrandProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalog_id?: InputMaybe<Scalars['ID']>;
  collection_id: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopCartAnalytics = {
  __typename?: 'ShopCartAnalytics';
  cart: Cart;
  gross_sales: Price;
  sales_success?: Maybe<BasketAnonymizedConnection>;
  shop: Shop;
};

export type ShopCartAnalyticsSales_SuccessArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopCartAnalyticsConnection = {
  __typename?: 'ShopCartAnalyticsConnection';
  edges?: Maybe<Array<Maybe<ShopCartAnalyticsEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ShopCartAnalyticsEdge = {
  __typename?: 'ShopCartAnalyticsEdge';
  cursor: Scalars['String'];
  node?: Maybe<ShopCartAnalytics>;
};

export type ShopConnection = {
  __typename?: 'ShopConnection';
  edges?: Maybe<Array<Maybe<ShopEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ShopCreateSfccInput = {
  clientId: Scalars['String'];
  clientPassword: Scalars['String'];
  display_name?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
  shortCode: Scalars['String'];
  siteId: Scalars['String'];
  tenant: Scalars['String'];
};

export type ShopCreateShopifyInput = {
  name: Scalars['String'];
};

export type ShopCreateShopifyNativeInput = {
  display_name?: InputMaybe<Scalars['String']>;
  /** {shop_name}.myshopify.com */
  shop_name: Scalars['String'];
  /** The storefront token should have the correct permissions already */
  storefront_access_token: Scalars['String'];
};

export type ShopCreateShopifyOutput = {
  __typename?: 'ShopCreateShopifyOutput';
  redirect_to: Scalars['AbsoluteUrl'];
};

export type ShopCreatorAnalytics = {
  __typename?: 'ShopCreatorAnalytics';
  creator: Creator;
  gross_sales: Price;
  sales_success?: Maybe<BasketAnonymizedConnection>;
  shop: Shop;
  total_subscriptions: Scalars['Int'];
  total_unsubscriptions: Scalars['Int'];
};

export type ShopCreatorAnalyticsSales_SuccessArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopCreatorAnalyticsConnection = {
  __typename?: 'ShopCreatorAnalyticsConnection';
  edges?: Maybe<Array<Maybe<ShopCreatorAnalyticsEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ShopCreatorAnalyticsEdge = {
  __typename?: 'ShopCreatorAnalyticsEdge';
  cursor: Scalars['String'];
  node?: Maybe<ShopCreatorAnalytics>;
};

export type ShopEdge = {
  __typename?: 'ShopEdge';
  cursor: Scalars['String'];
  node?: Maybe<Shop>;
};

export type ShopEditInput = {
  avatar?: InputMaybe<Scalars['AbsoluteUrl']>;
  display_name?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  production_date?: InputMaybe<Scalars['DateTime']>;
};

export type ShopInviteCreatorInput = {
  creators: Array<CreatorInput>;
  id: Scalars['ID'];
};

export type ShopNative = Node &
  Shop & {
    __typename?: 'ShopNative';
    avatar?: Maybe<Scalars['AbsoluteUrl']>;
    carts?: Maybe<CartConnection>;
    catalogs?: Maybe<ProductCatalogConnection>;
    collections?: Maybe<ProductCollectionConnection>;
    created_at: Scalars['DateTime'];
    creators?: Maybe<CreatorConnection>;
    default_country_code?: Maybe<Scalars['String']>;
    default_currency?: Maybe<Scalars['String']>;
    display_name?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    production_date?: Maybe<Scalars['DateTime']>;
    products?: Maybe<ProductConnection>;
    provider: ShopProvider;
    updated_at: Scalars['DateTime'];
  };

export type ShopNativeCartsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopNativeCatalogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopNativeCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalog_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopNativeCreatorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopNativeProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalog_id?: InputMaybe<Scalars['ID']>;
  collection_id: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export enum ShopProvider {
  Brand = 'brand',
  Native = 'native',
  Sfcc = 'sfcc',
  Shopify = 'shopify',
  ShopifyNative = 'shopify_native',
}

export type ShopRemovePaymentProviderInput = {
  shop_id: Scalars['ID'];
};

export type ShopSfcc = Node &
  Shop & {
    __typename?: 'ShopSFCC';
    avatar?: Maybe<Scalars['AbsoluteUrl']>;
    carts?: Maybe<CartConnection>;
    catalogs?: Maybe<ProductCatalogConnection>;
    collections?: Maybe<ProductCollectionConnection>;
    created_at: Scalars['DateTime'];
    creators?: Maybe<CreatorConnection>;
    default_country_code?: Maybe<Scalars['String']>;
    default_currency?: Maybe<Scalars['String']>;
    display_name?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    production_date?: Maybe<Scalars['DateTime']>;
    products?: Maybe<ProductConnection>;
    provider: ShopProvider;
    updated_at: Scalars['DateTime'];
  };

export type ShopSfccCartsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopSfccCatalogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopSfccCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalog_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopSfccCreatorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopSfccProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalog_id?: InputMaybe<Scalars['ID']>;
  collection_id: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopShopify = Node &
  Shop & {
    __typename?: 'ShopShopify';
    avatar?: Maybe<Scalars['AbsoluteUrl']>;
    carts?: Maybe<CartConnection>;
    catalogs?: Maybe<ProductCatalogConnection>;
    collections?: Maybe<ProductCollectionConnection>;
    created_at: Scalars['DateTime'];
    creators?: Maybe<CreatorConnection>;
    default_country_code?: Maybe<Scalars['String']>;
    default_currency?: Maybe<Scalars['String']>;
    display_name?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    production_date?: Maybe<Scalars['DateTime']>;
    products?: Maybe<ProductConnection>;
    provider: ShopProvider;
    updated_at: Scalars['DateTime'];
  };

export type ShopShopifyCartsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopShopifyCatalogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopShopifyCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalog_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopShopifyCreatorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopShopifyProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalog_id?: InputMaybe<Scalars['ID']>;
  collection_id: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopShopifyNative = Node &
  Shop & {
    __typename?: 'ShopShopifyNative';
    avatar?: Maybe<Scalars['AbsoluteUrl']>;
    carts?: Maybe<CartConnection>;
    catalogs?: Maybe<ProductCatalogConnection>;
    collections?: Maybe<ProductCollectionConnection>;
    created_at: Scalars['DateTime'];
    creators?: Maybe<CreatorConnection>;
    default_country_code?: Maybe<Scalars['String']>;
    default_currency?: Maybe<Scalars['String']>;
    display_name?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    name: Scalars['String'];
    production_date?: Maybe<Scalars['DateTime']>;
    products?: Maybe<ProductConnection>;
    provider: ShopProvider;
    updated_at: Scalars['DateTime'];
  };

export type ShopShopifyNativeCartsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopShopifyNativeCatalogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopShopifyNativeCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalog_id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopShopifyNativeCreatorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ShopShopifyNativeProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  catalog_id?: InputMaybe<Scalars['ID']>;
  collection_id: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type SocialLink = {
  __typename?: 'SocialLink';
  full_url: Scalars['AbsoluteUrl'];
  handle: Scalars['String'];
  type: SocialLinkType;
};

export type SocialLinkInput = {
  handle: Scalars['String'];
  type: SocialLinkType;
};

export enum SocialLinkType {
  Instagram = 'instagram',
  Pinterest = 'pinterest',
  Tiktok = 'tiktok',
  Twitter = 'twitter',
  Unknown = 'unknown',
  Youtube = 'youtube',
}

export type Subscriber = {
  __typename?: 'Subscriber';
  created_at: Scalars['DateTime'];
  creator_id: Scalars['ID'];
  data?: Maybe<Scalars['JSON']>;
  is_subscribed: Scalars['Boolean'];
  phone_number: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type SubscriberChartRow = {
  __typename?: 'SubscriberChartRow';
  count: Scalars['Int'];
  date: Scalars['DateTime'];
};

export type SubscriberConnection = {
  __typename?: 'SubscriberConnection';
  edges?: Maybe<Array<Maybe<SubscriberEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SubscriberEdge = {
  __typename?: 'SubscriberEdge';
  cursor: Scalars['String'];
  node?: Maybe<Subscriber>;
};

export type Template = {
  __typename?: 'Template';
  cart_id?: Maybe<Scalars['ID']>;
  creator_id: Scalars['ID'];
  id: Scalars['ID'];
  media_url?: Maybe<Scalars['AbsoluteUrl']>;
  parameters?: Maybe<Scalars['JSONObject']>;
  template: Scalars['String'];
  type: TemplateType;
};

export type TemplateConnection = {
  __typename?: 'TemplateConnection';
  edges?: Maybe<Array<Maybe<TemplateEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TemplateDeleteOutput = {
  __typename?: 'TemplateDeleteOutput';
  success: Scalars['Boolean'];
};

export type TemplateEdge = {
  __typename?: 'TemplateEdge';
  cursor: Scalars['String'];
  node?: Maybe<Template>;
};

export enum TemplateType {
  Campaign = 'campaign',
  DiscountApplied = 'discount_applied',
  DiscountPopup = 'discount_popup',
  OnAlreadySubscribed = 'on_already_subscribed',
  OnOrderSuccess = 'on_order_success',
  OnSubscribe = 'on_subscribe',
  OnUnrecognizedMessage = 'on_unrecognized_message',
  OptIn = 'opt_in',
}

export type TemplateUpsertInput = {
  cart_id?: InputMaybe<Scalars['ID']>;
  creator_id: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  media_url?: InputMaybe<Scalars['AbsoluteUrl']>;
  parameters?: InputMaybe<Scalars['JSONObject']>;
  template: Scalars['String'];
  type: TemplateType;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['EmailAddress']>;
  id: Scalars['ID'];
  is_superadmin?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type UserAnonymized = Node &
  UserBase & {
    __typename?: 'UserAnonymized';
    id: Scalars['ID'];
    name?: Maybe<Scalars['String']>;
  };

export type UserAnonymizedConnection = {
  __typename?: 'UserAnonymizedConnection';
  edges?: Maybe<Array<Maybe<UserAnonymizedEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UserAnonymizedEdge = {
  __typename?: 'UserAnonymizedEdge';
  cursor: Scalars['String'];
  node?: Maybe<UserAnonymized>;
};

export type UserBase = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type UserCurrent = Node &
  UserBase & {
    __typename?: 'UserCurrent';
    brand?: Maybe<Scalars['String']>;
    creators: Array<Creator>;
    email: Scalars['EmailAddress'];
    id: Scalars['ID'];
    is_superadmin: Scalars['Boolean'];
    name?: Maybe<Scalars['String']>;
  };

export type UserFull = Node &
  UserBase & {
    __typename?: 'UserFull';
    brand?: Maybe<Scalars['String']>;
    email: Scalars['EmailAddress'];
    id: Scalars['ID'];
    is_approved?: Maybe<Scalars['Boolean']>;
    is_superadmin: Scalars['Boolean'];
    name?: Maybe<Scalars['String']>;
    role?: Maybe<Scalars['String']>;
  };

export type UserFullConnection = {
  __typename?: 'UserFullConnection';
  edges?: Maybe<Array<Maybe<UserFullEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UserFullEdge = {
  __typename?: 'UserFullEdge';
  cursor: Scalars['String'];
  node?: Maybe<UserFull>;
};

export enum VideoExtension {
  Mp4 = 'mp4',
}

export enum VideoResourceType {
  Template = 'template',
}

export type VideoUploadInput = {
  extension: VideoExtension;
  node_id: Scalars['ID'];
  resource_type: VideoResourceType;
};

export type VideoUploadOutput = {
  __typename?: 'VideoUploadOutput';
  signed_url: Scalars['AbsoluteUrl'];
  url: Scalars['AbsoluteUrl'];
};

export type BasketAddPaymentMethodMutationVariables = Exact<{
  input: BasketAddPaymentMethodInput;
}>;

export type BasketAddPaymentMethodMutation = {
  __typename?: 'Mutation';
  BasketAddPaymentMethod: {
    __typename?: 'Basket';
    id: string;
    cart_id: string;
    external_url?: any | null;
    shipping_method_id?: string | null;
    status?: BasketStatus | null;
    email?: any | null;
    created_at: any;
    updated_at: any;
    items: Array<{
      __typename?: 'BasketItem';
      sku: string;
      quantity: number;
      price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    }>;
    subtotal: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    shipping_cost?: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null } | null;
    taxes: Array<{
      __typename?: 'BasketTaxes';
      name: string;
      code: string;
      price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    }>;
    total?: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null } | null;
    billing_address?: {
      __typename?: 'AddressParent';
      name: string;
      phone: any;
      address: {
        __typename?: 'Address';
        city: string;
        country: string;
        line1: string;
        line2?: string | null;
        postal_code: string;
        state: string;
      };
    } | null;
    shipping_address?: {
      __typename?: 'AddressParent';
      name: string;
      phone: any;
      address: {
        __typename?: 'Address';
        city: string;
        country: string;
        line1: string;
        line2?: string | null;
        postal_code: string;
        state: string;
      };
    } | null;
    payment_method?: {
      __typename?: 'BasketPaymentMethod';
      last_four_digits: string;
      card_type: string;
      full_name: string;
      month: number;
      year: number;
    } | null;
    transaction?: { __typename?: 'BasketTransaction'; state: string } | null;
    order?: { __typename?: 'BasketOrder'; id: string } | null;
  };
};

export type BasketCreateMutationVariables = Exact<{
  input: BasketCreateInput;
}>;

export type BasketCreateMutation = {
  __typename?: 'Mutation';
  BasketCreate: {
    __typename?: 'Basket';
    id: string;
    cart_id: string;
    external_url?: any | null;
    shipping_method_id?: string | null;
    status?: BasketStatus | null;
    email?: any | null;
    created_at: any;
    updated_at: any;
    items: Array<{
      __typename?: 'BasketItem';
      sku: string;
      quantity: number;
      price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    }>;
    subtotal: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    shipping_cost?: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null } | null;
    taxes: Array<{
      __typename?: 'BasketTaxes';
      name: string;
      code: string;
      price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    }>;
    total?: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null } | null;
    billing_address?: {
      __typename?: 'AddressParent';
      name: string;
      phone: any;
      address: {
        __typename?: 'Address';
        city: string;
        country: string;
        line1: string;
        line2?: string | null;
        postal_code: string;
        state: string;
      };
    } | null;
    shipping_address?: {
      __typename?: 'AddressParent';
      name: string;
      phone: any;
      address: {
        __typename?: 'Address';
        city: string;
        country: string;
        line1: string;
        line2?: string | null;
        postal_code: string;
        state: string;
      };
    } | null;
    payment_method?: {
      __typename?: 'BasketPaymentMethod';
      last_four_digits: string;
      card_type: string;
      full_name: string;
      month: number;
      year: number;
    } | null;
    transaction?: { __typename?: 'BasketTransaction'; state: string } | null;
    order?: { __typename?: 'BasketOrder'; id: string } | null;
  };
};

export type BasketFinalizeMutationVariables = Exact<{
  input: BasketFinalizeInput;
}>;

export type BasketFinalizeMutation = {
  __typename?: 'Mutation';
  BasketFinalize?: {
    __typename?: 'Basket';
    id: string;
    cart_id: string;
    external_url?: any | null;
    shipping_method_id?: string | null;
    status?: BasketStatus | null;
    email?: any | null;
    created_at: any;
    updated_at: any;
    items: Array<{
      __typename?: 'BasketItem';
      sku: string;
      quantity: number;
      price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    }>;
    subtotal: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    shipping_cost?: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null } | null;
    taxes: Array<{
      __typename?: 'BasketTaxes';
      name: string;
      code: string;
      price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    }>;
    total?: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null } | null;
    billing_address?: {
      __typename?: 'AddressParent';
      name: string;
      phone: any;
      address: {
        __typename?: 'Address';
        city: string;
        country: string;
        line1: string;
        line2?: string | null;
        postal_code: string;
        state: string;
      };
    } | null;
    shipping_address?: {
      __typename?: 'AddressParent';
      name: string;
      phone: any;
      address: {
        __typename?: 'Address';
        city: string;
        country: string;
        line1: string;
        line2?: string | null;
        postal_code: string;
        state: string;
      };
    } | null;
    payment_method?: {
      __typename?: 'BasketPaymentMethod';
      last_four_digits: string;
      card_type: string;
      full_name: string;
      month: number;
      year: number;
    } | null;
    transaction?: { __typename?: 'BasketTransaction'; state: string } | null;
    order?: { __typename?: 'BasketOrder'; id: string } | null;
  } | null;
};

export type BasketPrepareOrderMutationVariables = Exact<{
  input: BasketPrepareOrderInput;
}>;

export type BasketPrepareOrderMutation = {
  __typename?: 'Mutation';
  BasketPrepareOrder: {
    __typename?: 'Basket';
    id: string;
    cart_id: string;
    external_url?: any | null;
    shipping_method_id?: string | null;
    status?: BasketStatus | null;
    email?: any | null;
    created_at: any;
    updated_at: any;
    items: Array<{
      __typename?: 'BasketItem';
      sku: string;
      quantity: number;
      price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    }>;
    subtotal: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    shipping_cost?: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null } | null;
    taxes: Array<{
      __typename?: 'BasketTaxes';
      name: string;
      code: string;
      price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    }>;
    total?: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null } | null;
    billing_address?: {
      __typename?: 'AddressParent';
      name: string;
      phone: any;
      address: {
        __typename?: 'Address';
        city: string;
        country: string;
        line1: string;
        line2?: string | null;
        postal_code: string;
        state: string;
      };
    } | null;
    shipping_address?: {
      __typename?: 'AddressParent';
      name: string;
      phone: any;
      address: {
        __typename?: 'Address';
        city: string;
        country: string;
        line1: string;
        line2?: string | null;
        postal_code: string;
        state: string;
      };
    } | null;
    payment_method?: {
      __typename?: 'BasketPaymentMethod';
      last_four_digits: string;
      card_type: string;
      full_name: string;
      month: number;
      year: number;
    } | null;
    transaction?: { __typename?: 'BasketTransaction'; state: string } | null;
    order?: { __typename?: 'BasketOrder'; id: string } | null;
  };
};

export type BasketUpdateMutationVariables = Exact<{
  input: BasketUpdateInput;
}>;

export type BasketUpdateMutation = {
  __typename?: 'Mutation';
  BasketUpdate: {
    __typename?: 'Basket';
    id: string;
    cart_id: string;
    external_url?: any | null;
    shipping_method_id?: string | null;
    status?: BasketStatus | null;
    email?: any | null;
    created_at: any;
    updated_at: any;
    items: Array<{
      __typename?: 'BasketItem';
      sku: string;
      quantity: number;
      price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    }>;
    subtotal: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    shipping_cost?: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null } | null;
    taxes: Array<{
      __typename?: 'BasketTaxes';
      name: string;
      code: string;
      price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    }>;
    total?: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null } | null;
    billing_address?: {
      __typename?: 'AddressParent';
      name: string;
      phone: any;
      address: {
        __typename?: 'Address';
        city: string;
        country: string;
        line1: string;
        line2?: string | null;
        postal_code: string;
        state: string;
      };
    } | null;
    shipping_address?: {
      __typename?: 'AddressParent';
      name: string;
      phone: any;
      address: {
        __typename?: 'Address';
        city: string;
        country: string;
        line1: string;
        line2?: string | null;
        postal_code: string;
        state: string;
      };
    } | null;
    payment_method?: {
      __typename?: 'BasketPaymentMethod';
      last_four_digits: string;
      card_type: string;
      full_name: string;
      month: number;
      year: number;
    } | null;
    transaction?: { __typename?: 'BasketTransaction'; state: string } | null;
    order?: { __typename?: 'BasketOrder'; id: string } | null;
  };
};

export type ConversionTrackMutationVariables = Exact<{
  input: ConversionInput;
}>;

export type ConversionTrackMutation = {
  __typename?: 'Mutation';
  ConversionTrack: {
    __typename?: 'LiteConversion';
    campaign: string;
    action: string;
    ip?: string | null;
    userAgent?: string | null;
    referrer?: string | null;
    phoneNumber?: string | null;
  };
};

export type ReservationAddMutationVariables = Exact<{
  input: ReservationAddInput;
}>;

export type ReservationAddMutation = {
  __typename?: 'Mutation';
  ReservationAdd: { __typename?: 'Reservation'; id: string; phone_number: string; slug: string };
};

export type BasketQueryVariables = Exact<{
  creator_slug: Scalars['String'];
  slug: Scalars['String'];
  basketId: Scalars['ID'];
}>;

export type BasketQuery = {
  __typename?: 'Query';
  Basket: {
    __typename?: 'Basket';
    id: string;
    cart_id: string;
    external_url?: any | null;
    shipping_method_id?: string | null;
    status?: BasketStatus | null;
    email?: any | null;
    created_at: any;
    updated_at: any;
    items: Array<{
      __typename?: 'BasketItem';
      sku: string;
      quantity: number;
      price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    }>;
    subtotal: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    shipping_cost?: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null } | null;
    taxes: Array<{
      __typename?: 'BasketTaxes';
      name: string;
      code: string;
      price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    }>;
    total?: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null } | null;
    billing_address?: {
      __typename?: 'AddressParent';
      name: string;
      phone: any;
      address: {
        __typename?: 'Address';
        city: string;
        country: string;
        line1: string;
        line2?: string | null;
        postal_code: string;
        state: string;
      };
    } | null;
    shipping_address?: {
      __typename?: 'AddressParent';
      name: string;
      phone: any;
      address: {
        __typename?: 'Address';
        city: string;
        country: string;
        line1: string;
        line2?: string | null;
        postal_code: string;
        state: string;
      };
    } | null;
    payment_method?: {
      __typename?: 'BasketPaymentMethod';
      last_four_digits: string;
      card_type: string;
      full_name: string;
      month: number;
      year: number;
    } | null;
    transaction?: { __typename?: 'BasketTransaction'; state: string } | null;
    order?: { __typename?: 'BasketOrder'; id: string } | null;
  };
  Cart: {
    __typename?: 'Cart';
    id: string;
    slug: string;
    testimonial?: string | null;
    promo_message?: string | null;
    popup_discounts?: boolean | null;
    popup_timeout?: number | null;
    discount_code?: string | null;
    discount_message_template?: string | null;
    discount_applied_template?: string | null;
    tax_shipping_label?: string | null;
    requires_auth: boolean;
    theme?: string | null;
    creator: {
      __typename?: 'Creator';
      id: string;
      slug: string;
      avatar?: any | null;
      socials: Array<{ __typename?: 'SocialLink'; handle: string; type: SocialLinkType; full_url: any }>;
    };
    shop?:
      | {
          __typename?: 'ShopBrand';
          avatar?: any | null;
          display_name?: string | null;
          default_currency?: string | null;
          default_country_code?: string | null;
        }
      | {
          __typename?: 'ShopNative';
          avatar?: any | null;
          display_name?: string | null;
          default_currency?: string | null;
          default_country_code?: string | null;
        }
      | {
          __typename?: 'ShopSFCC';
          avatar?: any | null;
          display_name?: string | null;
          default_currency?: string | null;
          default_country_code?: string | null;
        }
      | {
          __typename?: 'ShopShopify';
          avatar?: any | null;
          display_name?: string | null;
          default_currency?: string | null;
          default_country_code?: string | null;
        }
      | {
          __typename?: 'ShopShopifyNative';
          avatar?: any | null;
          display_name?: string | null;
          default_currency?: string | null;
          default_country_code?: string | null;
        }
      | null;
    items: Array<{
      __typename?: 'Product';
      id: string;
      name: string;
      description?: string | null;
      images: Array<{ __typename?: 'Image'; url: any; alt?: string | null }>;
      options: Array<{
        __typename?: 'ProductOption';
        type: ProductOptionType;
        value: string;
        label: string;
        choices: Array<{
          __typename?: 'ProductOptionChoice';
          value: string;
          label: string;
          image?: { __typename?: 'Image'; url: any; alt?: string | null } | null;
        }>;
      }>;
      variants: Array<{
        __typename?: 'ProductVariant';
        id: string;
        sku: string;
        name: string;
        description?: string | null;
        variations: Record<string, unknown>;
        soldOut?: boolean | null;
        images: Array<{ __typename?: 'Image'; url: any; alt?: string | null }>;
        prices: Array<{ __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null }>;
        price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
      }>;
    }>;
  };
  CartUserCurrent?: { __typename?: 'CartUserCurrent'; id: string; phone_number: any } | null;
  BasketShippingMethods: Array<{
    __typename?: 'BasketShippingMethod';
    id: string;
    name: string;
    is_default: boolean;
    price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
  }>;
};

export type BasketShippingMethodsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type BasketShippingMethodsQuery = {
  __typename?: 'Query';
  BasketShippingMethods: Array<{
    __typename?: 'BasketShippingMethod';
    id: string;
    name: string;
    is_default: boolean;
    price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
  }>;
};

export type CampaignSubscribeQueryVariables = Exact<{
  creator_slug: Scalars['String'];
  slug: Scalars['String'];
}>;

export type CampaignSubscribeQuery = {
  __typename?: 'Query';
  CampaignSubscribe?: { __typename?: 'CampaignSubscribe'; campaign_id: string; phone_number: any; body: string } | null;
};

export type CartQueryVariables = Exact<{
  creator_slug: Scalars['String'];
  slug: Scalars['String'];
}>;

export type CartQuery = {
  __typename?: 'Query';
  Cart: {
    __typename?: 'Cart';
    id: string;
    slug: string;
    testimonial?: string | null;
    promo_message?: string | null;
    popup_discounts?: boolean | null;
    popup_timeout?: number | null;
    discount_code?: string | null;
    discount_message_template?: string | null;
    discount_applied_template?: string | null;
    tax_shipping_label?: string | null;
    requires_auth: boolean;
    theme?: string | null;
    creator: {
      __typename?: 'Creator';
      id: string;
      slug: string;
      avatar?: any | null;
      socials: Array<{ __typename?: 'SocialLink'; handle: string; type: SocialLinkType; full_url: any }>;
    };
    shop?:
      | {
          __typename?: 'ShopBrand';
          avatar?: any | null;
          display_name?: string | null;
          default_currency?: string | null;
          default_country_code?: string | null;
        }
      | {
          __typename?: 'ShopNative';
          avatar?: any | null;
          display_name?: string | null;
          default_currency?: string | null;
          default_country_code?: string | null;
        }
      | {
          __typename?: 'ShopSFCC';
          avatar?: any | null;
          display_name?: string | null;
          default_currency?: string | null;
          default_country_code?: string | null;
        }
      | {
          __typename?: 'ShopShopify';
          avatar?: any | null;
          display_name?: string | null;
          default_currency?: string | null;
          default_country_code?: string | null;
        }
      | {
          __typename?: 'ShopShopifyNative';
          avatar?: any | null;
          display_name?: string | null;
          default_currency?: string | null;
          default_country_code?: string | null;
        }
      | null;
    items: Array<{
      __typename?: 'Product';
      id: string;
      name: string;
      description?: string | null;
      images: Array<{ __typename?: 'Image'; url: any; alt?: string | null }>;
      options: Array<{
        __typename?: 'ProductOption';
        type: ProductOptionType;
        value: string;
        label: string;
        choices: Array<{
          __typename?: 'ProductOptionChoice';
          value: string;
          label: string;
          image?: { __typename?: 'Image'; url: any; alt?: string | null } | null;
        }>;
      }>;
      variants: Array<{
        __typename?: 'ProductVariant';
        id: string;
        sku: string;
        name: string;
        description?: string | null;
        variations: Record<string, unknown>;
        soldOut?: boolean | null;
        images: Array<{ __typename?: 'Image'; url: any; alt?: string | null }>;
        prices: Array<{ __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null }>;
        price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
      }>;
    }>;
  };
};

export type ShopifyCartQueryVariables = Exact<{
  creator_slug: Scalars['String'];
  slug: Scalars['String'];
}>;

export type ShopifyCartQuery = {
  __typename?: 'Query';
  Cart: {
    __typename?: 'Cart';
    id: string;
    slug: string;
    testimonial?: string | null;
    promo_message?: string | null;
    popup_discounts?: boolean | null;
    popup_timeout?: number | null;
    discount_code?: string | null;
    discount_message_template?: string | null;
    discount_applied_template?: string | null;
    tax_shipping_label?: string | null;
    requires_auth: boolean;
    theme?: string | null;
    creator: {
      __typename?: 'Creator';
      id: string;
      slug: string;
      avatar?: any | null;
      socials: Array<{ __typename?: 'SocialLink'; handle: string; type: SocialLinkType; full_url: any }>;
    };
    shop?:
      | {
          __typename?: 'ShopBrand';
          avatar?: any | null;
          display_name?: string | null;
          default_currency?: string | null;
          default_country_code?: string | null;
        }
      | {
          __typename?: 'ShopNative';
          avatar?: any | null;
          display_name?: string | null;
          default_currency?: string | null;
          default_country_code?: string | null;
        }
      | {
          __typename?: 'ShopSFCC';
          avatar?: any | null;
          display_name?: string | null;
          default_currency?: string | null;
          default_country_code?: string | null;
        }
      | {
          __typename?: 'ShopShopify';
          avatar?: any | null;
          display_name?: string | null;
          default_currency?: string | null;
          default_country_code?: string | null;
        }
      | {
          __typename?: 'ShopShopifyNative';
          avatar?: any | null;
          display_name?: string | null;
          default_currency?: string | null;
          default_country_code?: string | null;
        }
      | null;
  };
};

export type CartShopProviderQueryVariables = Exact<{
  creator_slug: Scalars['String'];
  slug: Scalars['String'];
}>;

export type CartShopProviderQuery = {
  __typename?: 'Query';
  Cart: {
    __typename?: 'Cart';
    shop?:
      | { __typename?: 'ShopBrand'; provider: ShopProvider }
      | { __typename?: 'ShopNative'; provider: ShopProvider }
      | { __typename?: 'ShopSFCC'; provider: ShopProvider }
      | { __typename?: 'ShopShopify'; provider: ShopProvider }
      | { __typename?: 'ShopShopifyNative'; provider: ShopProvider }
      | null;
  };
};

export type CartSubscribeQueryVariables = Exact<{
  creator_slug: Scalars['String'];
  slug: Scalars['String'];
}>;

export type CartSubscribeQuery = { __typename?: 'Query'; CartSubscribe: { __typename?: 'CartSubscribe'; phone_number: any; body: string } };

export type GeolocationQueryVariables = Exact<{ [key: string]: never }>;

export type GeolocationQuery = {
  __typename?: 'Query';
  Geolocation: { __typename?: 'Geolocation'; country_code: any; city: string; calling_code: string };
};

export type InvoiceQueryVariables = Exact<{
  basket_id: Scalars['ID'];
  payment_intent_id: Scalars['ID'];
}>;

export type InvoiceQuery = {
  __typename?: 'Query';
  Invoice: {
    __typename?: 'Invoice';
    basket: {
      __typename?: 'Basket';
      id: string;
      cart_id: string;
      external_url?: any | null;
      shipping_method_id?: string | null;
      status?: BasketStatus | null;
      email?: any | null;
      created_at: any;
      updated_at: any;
      items: Array<{
        __typename?: 'BasketItem';
        sku: string;
        quantity: number;
        price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
      }>;
      subtotal: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
      shipping_cost?: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null } | null;
      taxes: Array<{
        __typename?: 'BasketTaxes';
        name: string;
        code: string;
        price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
      }>;
      total?: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null } | null;
      billing_address?: {
        __typename?: 'AddressParent';
        name: string;
        phone: any;
        address: {
          __typename?: 'Address';
          city: string;
          country: string;
          line1: string;
          line2?: string | null;
          postal_code: string;
          state: string;
        };
      } | null;
      shipping_address?: {
        __typename?: 'AddressParent';
        name: string;
        phone: any;
        address: {
          __typename?: 'Address';
          city: string;
          country: string;
          line1: string;
          line2?: string | null;
          postal_code: string;
          state: string;
        };
      } | null;
      payment_method?: {
        __typename?: 'BasketPaymentMethod';
        last_four_digits: string;
        card_type: string;
        full_name: string;
        month: number;
        year: number;
      } | null;
      transaction?: { __typename?: 'BasketTransaction'; state: string } | null;
      order?: { __typename?: 'BasketOrder'; id: string } | null;
    };
    cart: {
      __typename?: 'Cart';
      id: string;
      slug: string;
      testimonial?: string | null;
      promo_message?: string | null;
      popup_discounts?: boolean | null;
      popup_timeout?: number | null;
      discount_code?: string | null;
      discount_message_template?: string | null;
      discount_applied_template?: string | null;
      tax_shipping_label?: string | null;
      requires_auth: boolean;
      theme?: string | null;
      creator: {
        __typename?: 'Creator';
        id: string;
        slug: string;
        avatar?: any | null;
        socials: Array<{ __typename?: 'SocialLink'; handle: string; type: SocialLinkType; full_url: any }>;
      };
      shop?:
        | {
            __typename?: 'ShopBrand';
            avatar?: any | null;
            display_name?: string | null;
            default_currency?: string | null;
            default_country_code?: string | null;
          }
        | {
            __typename?: 'ShopNative';
            avatar?: any | null;
            display_name?: string | null;
            default_currency?: string | null;
            default_country_code?: string | null;
          }
        | {
            __typename?: 'ShopSFCC';
            avatar?: any | null;
            display_name?: string | null;
            default_currency?: string | null;
            default_country_code?: string | null;
          }
        | {
            __typename?: 'ShopShopify';
            avatar?: any | null;
            display_name?: string | null;
            default_currency?: string | null;
            default_country_code?: string | null;
          }
        | {
            __typename?: 'ShopShopifyNative';
            avatar?: any | null;
            display_name?: string | null;
            default_currency?: string | null;
            default_country_code?: string | null;
          }
        | null;
      items: Array<{
        __typename?: 'Product';
        id: string;
        name: string;
        description?: string | null;
        images: Array<{ __typename?: 'Image'; url: any; alt?: string | null }>;
        options: Array<{
          __typename?: 'ProductOption';
          type: ProductOptionType;
          value: string;
          label: string;
          choices: Array<{
            __typename?: 'ProductOptionChoice';
            value: string;
            label: string;
            image?: { __typename?: 'Image'; url: any; alt?: string | null } | null;
          }>;
        }>;
        variants: Array<{
          __typename?: 'ProductVariant';
          id: string;
          sku: string;
          name: string;
          description?: string | null;
          variations: Record<string, unknown>;
          soldOut?: boolean | null;
          images: Array<{ __typename?: 'Image'; url: any; alt?: string | null }>;
          prices: Array<{ __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null }>;
          price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
        }>;
      }>;
    };
  };
};

export type LiteCampaignProductQueryVariables = Exact<{
  creator_slug: Scalars['String'];
  slug: Scalars['String'];
}>;

export type LiteCampaignProductQuery = {
  __typename?: 'Query';
  LiteCampaignWithSlug: {
    __typename?: 'LiteCampaign';
    id: string;
    links?: Array<{ __typename?: 'ProductLink'; link: string; slug: string } | null> | null;
  };
};

export type BasketFragment = {
  __typename?: 'Basket';
  id: string;
  cart_id: string;
  external_url?: any | null;
  shipping_method_id?: string | null;
  status?: BasketStatus | null;
  email?: any | null;
  created_at: any;
  updated_at: any;
  items: Array<{
    __typename?: 'BasketItem';
    sku: string;
    quantity: number;
    price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
  }>;
  subtotal: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
  shipping_cost?: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null } | null;
  taxes: Array<{
    __typename?: 'BasketTaxes';
    name: string;
    code: string;
    price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
  }>;
  total?: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null } | null;
  billing_address?: {
    __typename?: 'AddressParent';
    name: string;
    phone: any;
    address: {
      __typename?: 'Address';
      city: string;
      country: string;
      line1: string;
      line2?: string | null;
      postal_code: string;
      state: string;
    };
  } | null;
  shipping_address?: {
    __typename?: 'AddressParent';
    name: string;
    phone: any;
    address: {
      __typename?: 'Address';
      city: string;
      country: string;
      line1: string;
      line2?: string | null;
      postal_code: string;
      state: string;
    };
  } | null;
  payment_method?: {
    __typename?: 'BasketPaymentMethod';
    last_four_digits: string;
    card_type: string;
    full_name: string;
    month: number;
    year: number;
  } | null;
  transaction?: { __typename?: 'BasketTransaction'; state: string } | null;
  order?: { __typename?: 'BasketOrder'; id: string } | null;
};

export type PriceFieldsFragment = { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };

export type AddressParentFieldsFragment = { __typename?: 'AddressParent'; name: string; phone: any };

export type AddressFieldsFragment = {
  __typename?: 'Address';
  city: string;
  country: string;
  line1: string;
  line2?: string | null;
  postal_code: string;
  state: string;
};

export type CartFragment = {
  __typename?: 'Cart';
  id: string;
  slug: string;
  testimonial?: string | null;
  promo_message?: string | null;
  popup_discounts?: boolean | null;
  popup_timeout?: number | null;
  discount_code?: string | null;
  discount_message_template?: string | null;
  discount_applied_template?: string | null;
  tax_shipping_label?: string | null;
  requires_auth: boolean;
  theme?: string | null;
  creator: {
    __typename?: 'Creator';
    id: string;
    slug: string;
    avatar?: any | null;
    socials: Array<{ __typename?: 'SocialLink'; handle: string; type: SocialLinkType; full_url: any }>;
  };
  shop?:
    | {
        __typename?: 'ShopBrand';
        avatar?: any | null;
        display_name?: string | null;
        default_currency?: string | null;
        default_country_code?: string | null;
      }
    | {
        __typename?: 'ShopNative';
        avatar?: any | null;
        display_name?: string | null;
        default_currency?: string | null;
        default_country_code?: string | null;
      }
    | {
        __typename?: 'ShopSFCC';
        avatar?: any | null;
        display_name?: string | null;
        default_currency?: string | null;
        default_country_code?: string | null;
      }
    | {
        __typename?: 'ShopShopify';
        avatar?: any | null;
        display_name?: string | null;
        default_currency?: string | null;
        default_country_code?: string | null;
      }
    | {
        __typename?: 'ShopShopifyNative';
        avatar?: any | null;
        display_name?: string | null;
        default_currency?: string | null;
        default_country_code?: string | null;
      }
    | null;
  items: Array<{
    __typename?: 'Product';
    id: string;
    name: string;
    description?: string | null;
    images: Array<{ __typename?: 'Image'; url: any; alt?: string | null }>;
    options: Array<{
      __typename?: 'ProductOption';
      type: ProductOptionType;
      value: string;
      label: string;
      choices: Array<{
        __typename?: 'ProductOptionChoice';
        value: string;
        label: string;
        image?: { __typename?: 'Image'; url: any; alt?: string | null } | null;
      }>;
    }>;
    variants: Array<{
      __typename?: 'ProductVariant';
      id: string;
      sku: string;
      name: string;
      description?: string | null;
      variations: Record<string, unknown>;
      soldOut?: boolean | null;
      images: Array<{ __typename?: 'Image'; url: any; alt?: string | null }>;
      prices: Array<{ __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null }>;
      price: { __typename?: 'Price'; currency: string; amount: number; old_amount?: number | null };
    }>;
  }>;
};

export type ConversionFragment = {
  __typename?: 'LiteConversion';
  campaign: string;
  action: string;
  ip?: string | null;
  userAgent?: string | null;
  referrer?: string | null;
  phoneNumber?: string | null;
};

export type WithTypename<T extends { __typename?: any }> = Partial<T> & { __typename: NonNullable<T['__typename']> };

export type GraphCacheKeysConfig = {
  Address?: (data: WithTypename<Address>) => null | string;
  AddressParent?: (data: WithTypename<AddressParent>) => null | string;
  AnonymizedAddress?: (data: WithTypename<AnonymizedAddress>) => null | string;
  AnonymizedAddressParent?: (data: WithTypename<AnonymizedAddressParent>) => null | string;
  Basket?: (data: WithTypename<Basket>) => null | string;
  BasketAnonymized?: (data: WithTypename<BasketAnonymized>) => null | string;
  BasketAnonymizedConnection?: (data: WithTypename<BasketAnonymizedConnection>) => null | string;
  BasketAnonymizedEdge?: (data: WithTypename<BasketAnonymizedEdge>) => null | string;
  BasketItem?: (data: WithTypename<BasketItem>) => null | string;
  BasketOrder?: (data: WithTypename<BasketOrder>) => null | string;
  BasketPaymentMethod?: (data: WithTypename<BasketPaymentMethod>) => null | string;
  BasketShippingMethod?: (data: WithTypename<BasketShippingMethod>) => null | string;
  BasketTaxes?: (data: WithTypename<BasketTaxes>) => null | string;
  BasketTransaction?: (data: WithTypename<BasketTransaction>) => null | string;
  CampaignSubscribe?: (data: WithTypename<CampaignSubscribe>) => null | string;
  Cart?: (data: WithTypename<Cart>) => null | string;
  CartConnection?: (data: WithTypename<CartConnection>) => null | string;
  CartEdge?: (data: WithTypename<CartEdge>) => null | string;
  CartSalesRow?: (data: WithTypename<CartSalesRow>) => null | string;
  CartSubscribe?: (data: WithTypename<CartSubscribe>) => null | string;
  CartUserCurrent?: (data: WithTypename<CartUserCurrent>) => null | string;
  ChartRow?: (data: WithTypename<ChartRow>) => null | string;
  Creator?: (data: WithTypename<Creator>) => null | string;
  CreatorAnalytics?: (data: WithTypename<CreatorAnalytics>) => null | string;
  CreatorCartAnalytics?: (data: WithTypename<CreatorCartAnalytics>) => null | string;
  CreatorCartAnalyticsConnection?: (data: WithTypename<CreatorCartAnalyticsConnection>) => null | string;
  CreatorCartAnalyticsEdge?: (data: WithTypename<CreatorCartAnalyticsEdge>) => null | string;
  CreatorConnection?: (data: WithTypename<CreatorConnection>) => null | string;
  CreatorEdge?: (data: WithTypename<CreatorEdge>) => null | string;
  Geolocation?: (data: WithTypename<Geolocation>) => null | string;
  Image?: (data: WithTypename<Image>) => null | string;
  ImageUploadOutput?: (data: WithTypename<ImageUploadOutput>) => null | string;
  Invoice?: (data: WithTypename<Invoice>) => null | string;
  LiteAnalytics?: (data: WithTypename<LiteAnalytics>) => null | string;
  LiteAnalyticsMetrics?: (data: WithTypename<LiteAnalyticsMetrics>) => null | string;
  LiteCampaign?: (data: WithTypename<LiteCampaign>) => null | string;
  LiteCampaignConnection?: (data: WithTypename<LiteCampaignConnection>) => null | string;
  LiteCampaignEdge?: (data: WithTypename<LiteCampaignEdge>) => null | string;
  LiteConversion?: (data: WithTypename<LiteConversion>) => null | string;
  LiteProductLinkStats?: (data: WithTypename<LiteProductLinkStats>) => null | string;
  PageInfo?: (data: WithTypename<PageInfo>) => null | string;
  PaymentGateway?: (data: WithTypename<PaymentGateway>) => null | string;
  PaymentGatewayAuthMode?: (data: WithTypename<PaymentGatewayAuthMode>) => null | string;
  PaymentGatewayCredential?: (data: WithTypename<PaymentGatewayCredential>) => null | string;
  PaymentMethod?: (data: WithTypename<PaymentMethod>) => null | string;
  PaymentMethodBillingDetails?: (data: WithTypename<PaymentMethodBillingDetails>) => null | string;
  PaymentMethodCard?: (data: WithTypename<PaymentMethodCard>) => null | string;
  PaymentProvider?: (data: WithTypename<PaymentProvider>) => null | string;
  PaymentProviderShopifyConfig?: (data: WithTypename<PaymentProviderShopifyConfig>) => null | string;
  PaymentProviderSpreedlyConfig?: (data: WithTypename<PaymentProviderSpreedlyConfig>) => null | string;
  PhoneNumberDetails?: (data: WithTypename<PhoneNumberDetails>) => null | string;
  Price?: (data: WithTypename<Price>) => null | string;
  Product?: (data: WithTypename<Product>) => null | string;
  ProductCatalog?: (data: WithTypename<ProductCatalog>) => null | string;
  ProductCatalogConnection?: (data: WithTypename<ProductCatalogConnection>) => null | string;
  ProductCatalogEdge?: (data: WithTypename<ProductCatalogEdge>) => null | string;
  ProductCollection?: (data: WithTypename<ProductCollection>) => null | string;
  ProductCollectionConnection?: (data: WithTypename<ProductCollectionConnection>) => null | string;
  ProductCollectionEdge?: (data: WithTypename<ProductCollectionEdge>) => null | string;
  ProductConnection?: (data: WithTypename<ProductConnection>) => null | string;
  ProductEdge?: (data: WithTypename<ProductEdge>) => null | string;
  ProductLink?: (data: WithTypename<ProductLink>) => null | string;
  ProductOption?: (data: WithTypename<ProductOption>) => null | string;
  ProductOptionChoice?: (data: WithTypename<ProductOptionChoice>) => null | string;
  ProductOverride?: (data: WithTypename<ProductOverride>) => null | string;
  ProductVariant?: (data: WithTypename<ProductVariant>) => null | string;
  Reservation?: (data: WithTypename<Reservation>) => null | string;
  ShopAnalytics?: (data: WithTypename<ShopAnalytics>) => null | string;
  ShopBrand?: (data: WithTypename<ShopBrand>) => null | string;
  ShopCartAnalytics?: (data: WithTypename<ShopCartAnalytics>) => null | string;
  ShopCartAnalyticsConnection?: (data: WithTypename<ShopCartAnalyticsConnection>) => null | string;
  ShopCartAnalyticsEdge?: (data: WithTypename<ShopCartAnalyticsEdge>) => null | string;
  ShopConnection?: (data: WithTypename<ShopConnection>) => null | string;
  ShopCreateShopifyOutput?: (data: WithTypename<ShopCreateShopifyOutput>) => null | string;
  ShopCreatorAnalytics?: (data: WithTypename<ShopCreatorAnalytics>) => null | string;
  ShopCreatorAnalyticsConnection?: (data: WithTypename<ShopCreatorAnalyticsConnection>) => null | string;
  ShopCreatorAnalyticsEdge?: (data: WithTypename<ShopCreatorAnalyticsEdge>) => null | string;
  ShopEdge?: (data: WithTypename<ShopEdge>) => null | string;
  ShopNative?: (data: WithTypename<ShopNative>) => null | string;
  ShopSFCC?: (data: WithTypename<ShopSfcc>) => null | string;
  ShopShopify?: (data: WithTypename<ShopShopify>) => null | string;
  ShopShopifyNative?: (data: WithTypename<ShopShopifyNative>) => null | string;
  SocialLink?: (data: WithTypename<SocialLink>) => null | string;
  Subscriber?: (data: WithTypename<Subscriber>) => null | string;
  SubscriberChartRow?: (data: WithTypename<SubscriberChartRow>) => null | string;
  SubscriberConnection?: (data: WithTypename<SubscriberConnection>) => null | string;
  SubscriberEdge?: (data: WithTypename<SubscriberEdge>) => null | string;
  Template?: (data: WithTypename<Template>) => null | string;
  TemplateConnection?: (data: WithTypename<TemplateConnection>) => null | string;
  TemplateDeleteOutput?: (data: WithTypename<TemplateDeleteOutput>) => null | string;
  TemplateEdge?: (data: WithTypename<TemplateEdge>) => null | string;
  UserAnonymized?: (data: WithTypename<UserAnonymized>) => null | string;
  UserAnonymizedConnection?: (data: WithTypename<UserAnonymizedConnection>) => null | string;
  UserAnonymizedEdge?: (data: WithTypename<UserAnonymizedEdge>) => null | string;
  UserCurrent?: (data: WithTypename<UserCurrent>) => null | string;
  UserFull?: (data: WithTypename<UserFull>) => null | string;
  UserFullConnection?: (data: WithTypename<UserFullConnection>) => null | string;
  UserFullEdge?: (data: WithTypename<UserFullEdge>) => null | string;
  VideoUploadOutput?: (data: WithTypename<VideoUploadOutput>) => null | string;
};

export type GraphCacheResolvers = {
  Query?: {
    Basket?: GraphCacheResolver<WithTypename<Query>, QueryBasketArgs, WithTypename<Basket> | string>;
    BasketShippingMethods?: GraphCacheResolver<
      WithTypename<Query>,
      QueryBasketShippingMethodsArgs,
      Array<WithTypename<BasketShippingMethod> | string>
    >;
    CampaignSubscribe?: GraphCacheResolver<WithTypename<Query>, QueryCampaignSubscribeArgs, WithTypename<CampaignSubscribe> | string>;
    Cart?: GraphCacheResolver<WithTypename<Query>, QueryCartArgs, WithTypename<Cart> | string>;
    CartById?: GraphCacheResolver<WithTypename<Query>, QueryCartByIdArgs, WithTypename<Cart> | string>;
    CartSubscribe?: GraphCacheResolver<WithTypename<Query>, QueryCartSubscribeArgs, WithTypename<CartSubscribe> | string>;
    CartUserCurrent?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<CartUserCurrent> | string>;
    Carts?: GraphCacheResolver<WithTypename<Query>, QueryCartsArgs, WithTypename<CartConnection> | string>;
    Conversions?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<LiteConversion> | string>>;
    Creator?: GraphCacheResolver<WithTypename<Query>, QueryCreatorArgs, WithTypename<Creator> | string>;
    CreatorAnalytics?: GraphCacheResolver<WithTypename<Query>, QueryCreatorAnalyticsArgs, WithTypename<CreatorAnalytics> | string>;
    CreatorWithSlug?: GraphCacheResolver<WithTypename<Query>, QueryCreatorWithSlugArgs, WithTypename<Creator> | string>;
    Creators?: GraphCacheResolver<WithTypename<Query>, QueryCreatorsArgs, WithTypename<CreatorConnection> | string>;
    Geolocation?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<Geolocation> | string>;
    Invoice?: GraphCacheResolver<WithTypename<Query>, QueryInvoiceArgs, WithTypename<Invoice> | string>;
    LiteCampaign?: GraphCacheResolver<WithTypename<Query>, QueryLiteCampaignArgs, WithTypename<LiteCampaign> | string>;
    LiteCampaignWithSlug?: GraphCacheResolver<WithTypename<Query>, QueryLiteCampaignWithSlugArgs, WithTypename<LiteCampaign> | string>;
    LiteCampaigns?: GraphCacheResolver<WithTypename<Query>, QueryLiteCampaignsArgs, WithTypename<LiteCampaignConnection> | string>;
    LiteCampaignsAnalytics?: GraphCacheResolver<WithTypename<Query>, QueryLiteCampaignsAnalyticsArgs, WithTypename<LiteAnalytics> | string>;
    Node?: GraphCacheResolver<
      WithTypename<Query>,
      QueryNodeArgs,
      | WithTypename<ShopBrand>
      | WithTypename<ShopNative>
      | WithTypename<ShopSfcc>
      | WithTypename<ShopShopify>
      | WithTypename<ShopShopifyNative>
      | WithTypename<UserAnonymized>
      | WithTypename<UserCurrent>
      | WithTypename<UserFull>
      | string
    >;
    PaymentGatewaysList?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<PaymentGateway> | string>>;
    PhoneNumbersAvailable?: GraphCacheResolver<
      WithTypename<Query>,
      QueryPhoneNumbersAvailableArgs,
      Array<WithTypename<PhoneNumberDetails> | string>
    >;
    Shop?: GraphCacheResolver<
      WithTypename<Query>,
      QueryShopArgs,
      | WithTypename<ShopBrand>
      | WithTypename<ShopNative>
      | WithTypename<ShopSfcc>
      | WithTypename<ShopShopify>
      | WithTypename<ShopShopifyNative>
      | string
    >;
    ShopAnalytics?: GraphCacheResolver<WithTypename<Query>, QueryShopAnalyticsArgs, WithTypename<ShopAnalytics> | string>;
    Shops?: GraphCacheResolver<WithTypename<Query>, QueryShopsArgs, WithTypename<ShopConnection> | string>;
    Subscribers?: GraphCacheResolver<WithTypename<Query>, QuerySubscribersArgs, WithTypename<SubscriberConnection> | string>;
    SubscribersChart?: GraphCacheResolver<WithTypename<Query>, QuerySubscribersChartArgs, Array<WithTypename<SubscriberChartRow> | string>>;
    Template?: GraphCacheResolver<WithTypename<Query>, QueryTemplateArgs, WithTypename<Template> | string>;
    Templates?: GraphCacheResolver<WithTypename<Query>, QueryTemplatesArgs, WithTypename<TemplateConnection> | string>;
    User?: GraphCacheResolver<WithTypename<Query>, QueryUserArgs, WithTypename<UserAnonymized> | string>;
    UserCurrent?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<UserCurrent> | string>;
    UserFull?: GraphCacheResolver<WithTypename<Query>, QueryUserFullArgs, WithTypename<UserFull> | string>;
    Users?: GraphCacheResolver<WithTypename<Query>, QueryUsersArgs, WithTypename<UserAnonymizedConnection> | string>;
    UsersList?: GraphCacheResolver<WithTypename<Query>, QueryUsersListArgs, WithTypename<UserFullConnection> | string>;
  };
  Address?: {
    city?: GraphCacheResolver<WithTypename<Address>, Record<string, never>, Scalars['String'] | string>;
    country?: GraphCacheResolver<WithTypename<Address>, Record<string, never>, Scalars['String'] | string>;
    line1?: GraphCacheResolver<WithTypename<Address>, Record<string, never>, Scalars['String'] | string>;
    line2?: GraphCacheResolver<WithTypename<Address>, Record<string, never>, Scalars['String'] | string>;
    postal_code?: GraphCacheResolver<WithTypename<Address>, Record<string, never>, Scalars['String'] | string>;
    state?: GraphCacheResolver<WithTypename<Address>, Record<string, never>, Scalars['String'] | string>;
  };
  AddressParent?: {
    address?: GraphCacheResolver<WithTypename<AddressParent>, Record<string, never>, WithTypename<Address> | string>;
    name?: GraphCacheResolver<WithTypename<AddressParent>, Record<string, never>, Scalars['String'] | string>;
    phone?: GraphCacheResolver<WithTypename<AddressParent>, Record<string, never>, Scalars['PhoneNumber'] | string>;
  };
  AnonymizedAddress?: {
    city?: GraphCacheResolver<WithTypename<AnonymizedAddress>, Record<string, never>, Scalars['String'] | string>;
    country?: GraphCacheResolver<WithTypename<AnonymizedAddress>, Record<string, never>, Scalars['String'] | string>;
    state?: GraphCacheResolver<WithTypename<AnonymizedAddress>, Record<string, never>, Scalars['String'] | string>;
  };
  AnonymizedAddressParent?: {
    address?: GraphCacheResolver<WithTypename<AnonymizedAddressParent>, Record<string, never>, WithTypename<AnonymizedAddress> | string>;
  };
  Basket?: {
    billing_address?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, WithTypename<AddressParent> | string>;
    cart_id?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, Scalars['String'] | string>;
    created_at?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, Scalars['DateTime'] | string>;
    email?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, Scalars['EmailAddress'] | string>;
    external_url?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, Scalars['AbsoluteUrl'] | string>;
    id?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, Scalars['ID'] | string>;
    items?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, Array<WithTypename<BasketItem> | string>>;
    order?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, WithTypename<BasketOrder> | string>;
    payment_method?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, WithTypename<BasketPaymentMethod> | string>;
    shipping_address?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, WithTypename<AddressParent> | string>;
    shipping_cost?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, WithTypename<Price> | string>;
    shipping_method_id?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, Scalars['ID'] | string>;
    status?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, BasketStatus | string>;
    subtotal?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, WithTypename<Price> | string>;
    taxes?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, Array<WithTypename<BasketTaxes> | string>>;
    total?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, WithTypename<Price> | string>;
    transaction?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, WithTypename<BasketTransaction> | string>;
    updated_at?: GraphCacheResolver<WithTypename<Basket>, Record<string, never>, Scalars['DateTime'] | string>;
  };
  BasketAnonymized?: {
    cart_user_id?: GraphCacheResolver<WithTypename<BasketAnonymized>, Record<string, never>, Scalars['ID'] | string>;
    created_at?: GraphCacheResolver<WithTypename<BasketAnonymized>, Record<string, never>, Scalars['DateTime'] | string>;
    id?: GraphCacheResolver<WithTypename<BasketAnonymized>, Record<string, never>, Scalars['ID'] | string>;
    items?: GraphCacheResolver<WithTypename<BasketAnonymized>, Record<string, never>, Array<WithTypename<BasketItem> | string>>;
    origin?: GraphCacheResolver<WithTypename<BasketAnonymized>, Record<string, never>, Scalars['String'] | string>;
    shipping_address?: GraphCacheResolver<
      WithTypename<BasketAnonymized>,
      Record<string, never>,
      WithTypename<AnonymizedAddressParent> | string
    >;
    shipping_cost?: GraphCacheResolver<WithTypename<BasketAnonymized>, Record<string, never>, WithTypename<Price> | string>;
    subtotal?: GraphCacheResolver<WithTypename<BasketAnonymized>, Record<string, never>, WithTypename<Price> | string>;
    taxes?: GraphCacheResolver<WithTypename<BasketAnonymized>, Record<string, never>, Array<WithTypename<BasketTaxes> | string>>;
    total?: GraphCacheResolver<WithTypename<BasketAnonymized>, Record<string, never>, WithTypename<Price> | string>;
  };
  BasketAnonymizedConnection?: {
    edges?: GraphCacheResolver<
      WithTypename<BasketAnonymizedConnection>,
      Record<string, never>,
      Array<WithTypename<BasketAnonymizedEdge> | string>
    >;
    pageInfo?: GraphCacheResolver<WithTypename<BasketAnonymizedConnection>, Record<string, never>, WithTypename<PageInfo> | string>;
    totalCount?: GraphCacheResolver<WithTypename<BasketAnonymizedConnection>, Record<string, never>, Scalars['Int'] | string>;
  };
  BasketAnonymizedEdge?: {
    cursor?: GraphCacheResolver<WithTypename<BasketAnonymizedEdge>, Record<string, never>, Scalars['String'] | string>;
    node?: GraphCacheResolver<WithTypename<BasketAnonymizedEdge>, Record<string, never>, WithTypename<BasketAnonymized> | string>;
  };
  BasketItem?: {
    price?: GraphCacheResolver<WithTypename<BasketItem>, Record<string, never>, WithTypename<Price> | string>;
    quantity?: GraphCacheResolver<WithTypename<BasketItem>, Record<string, never>, Scalars['Int'] | string>;
    sku?: GraphCacheResolver<WithTypename<BasketItem>, Record<string, never>, Scalars['ID'] | string>;
  };
  BasketOrder?: {
    id?: GraphCacheResolver<WithTypename<BasketOrder>, Record<string, never>, Scalars['ID'] | string>;
  };
  BasketPaymentMethod?: {
    card_type?: GraphCacheResolver<WithTypename<BasketPaymentMethod>, Record<string, never>, Scalars['String'] | string>;
    full_name?: GraphCacheResolver<WithTypename<BasketPaymentMethod>, Record<string, never>, Scalars['String'] | string>;
    last_four_digits?: GraphCacheResolver<WithTypename<BasketPaymentMethod>, Record<string, never>, Scalars['String'] | string>;
    month?: GraphCacheResolver<WithTypename<BasketPaymentMethod>, Record<string, never>, Scalars['Int'] | string>;
    token?: GraphCacheResolver<WithTypename<BasketPaymentMethod>, Record<string, never>, Scalars['String'] | string>;
    year?: GraphCacheResolver<WithTypename<BasketPaymentMethod>, Record<string, never>, Scalars['Int'] | string>;
  };
  BasketShippingMethod?: {
    id?: GraphCacheResolver<WithTypename<BasketShippingMethod>, Record<string, never>, Scalars['ID'] | string>;
    is_default?: GraphCacheResolver<WithTypename<BasketShippingMethod>, Record<string, never>, Scalars['Boolean'] | string>;
    name?: GraphCacheResolver<WithTypename<BasketShippingMethod>, Record<string, never>, Scalars['String'] | string>;
    price?: GraphCacheResolver<WithTypename<BasketShippingMethod>, Record<string, never>, WithTypename<Price> | string>;
  };
  BasketTaxes?: {
    code?: GraphCacheResolver<WithTypename<BasketTaxes>, Record<string, never>, Scalars['String'] | string>;
    name?: GraphCacheResolver<WithTypename<BasketTaxes>, Record<string, never>, Scalars['String'] | string>;
    price?: GraphCacheResolver<WithTypename<BasketTaxes>, Record<string, never>, WithTypename<Price> | string>;
  };
  BasketTransaction?: {
    state?: GraphCacheResolver<WithTypename<BasketTransaction>, Record<string, never>, Scalars['String'] | string>;
  };
  CampaignSubscribe?: {
    body?: GraphCacheResolver<WithTypename<CampaignSubscribe>, Record<string, never>, Scalars['String'] | string>;
    campaign_id?: GraphCacheResolver<WithTypename<CampaignSubscribe>, Record<string, never>, Scalars['ID'] | string>;
    phone_number?: GraphCacheResolver<WithTypename<CampaignSubscribe>, Record<string, never>, Scalars['PhoneNumber'] | string>;
  };
  Cart?: {
    catalog_id?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['String'] | string>;
    collection_id?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['String'] | string>;
    created_at?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['DateTime'] | string>;
    creator?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, WithTypename<Creator> | string>;
    creator_id?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['String'] | string>;
    discount_applied_template?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['String'] | string>;
    discount_code?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['String'] | string>;
    discount_message_template?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['String'] | string>;
    discount_percentage?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['Float'] | string>;
    gross_sales?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['Int'] | string>;
    id?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['ID'] | string>;
    popup_discounts?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['Boolean'] | string>;
    popup_timeout?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['Int'] | string>;
    products?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Array<WithTypename<Product> | string>>;
    products_overrides?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['JSON'] | string>;
    promo_message?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['String'] | string>;
    requires_auth?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['Boolean'] | string>;
    shop?: GraphCacheResolver<
      WithTypename<Cart>,
      Record<string, never>,
      | WithTypename<ShopBrand>
      | WithTypename<ShopNative>
      | WithTypename<ShopSfcc>
      | WithTypename<ShopShopify>
      | WithTypename<ShopShopifyNative>
      | string
    >;
    slug?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['String'] | string>;
    tax_shipping_label?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['String'] | string>;
    testimonial?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['String'] | string>;
    theme?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['String'] | string>;
    updated_at?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['DateTime'] | string>;
    whitelist_products?: GraphCacheResolver<WithTypename<Cart>, Record<string, never>, Scalars['JSON'] | string>;
  };
  CartConnection?: {
    edges?: GraphCacheResolver<WithTypename<CartConnection>, Record<string, never>, Array<WithTypename<CartEdge> | string>>;
    pageInfo?: GraphCacheResolver<WithTypename<CartConnection>, Record<string, never>, WithTypename<PageInfo> | string>;
    totalCount?: GraphCacheResolver<WithTypename<CartConnection>, Record<string, never>, Scalars['Int'] | string>;
  };
  CartEdge?: {
    cursor?: GraphCacheResolver<WithTypename<CartEdge>, Record<string, never>, Scalars['String'] | string>;
    node?: GraphCacheResolver<WithTypename<CartEdge>, Record<string, never>, WithTypename<Cart> | string>;
  };
  CartSalesRow?: {
    amount?: GraphCacheResolver<WithTypename<CartSalesRow>, Record<string, never>, Scalars['Int'] | string>;
    count?: GraphCacheResolver<WithTypename<CartSalesRow>, Record<string, never>, Scalars['Int'] | string>;
    date?: GraphCacheResolver<WithTypename<CartSalesRow>, Record<string, never>, Scalars['DateTime'] | string>;
  };
  CartSubscribe?: {
    body?: GraphCacheResolver<WithTypename<CartSubscribe>, Record<string, never>, Scalars['String'] | string>;
    phone_number?: GraphCacheResolver<WithTypename<CartSubscribe>, Record<string, never>, Scalars['PhoneNumber'] | string>;
  };
  CartUserCurrent?: {
    id?: GraphCacheResolver<WithTypename<CartUserCurrent>, Record<string, never>, Scalars['ID'] | string>;
    phone_number?: GraphCacheResolver<WithTypename<CartUserCurrent>, Record<string, never>, Scalars['PhoneNumber'] | string>;
  };
  ChartRow?: {
    count?: GraphCacheResolver<WithTypename<ChartRow>, Record<string, never>, Scalars['Int'] | string>;
    date?: GraphCacheResolver<WithTypename<ChartRow>, Record<string, never>, Scalars['DateTime'] | string>;
  };
  Creator?: {
    address_id?: GraphCacheResolver<WithTypename<Creator>, Record<string, never>, Scalars['String'] | string>;
    avatar?: GraphCacheResolver<WithTypename<Creator>, Record<string, never>, Scalars['AbsoluteUrl'] | string>;
    created_at?: GraphCacheResolver<WithTypename<Creator>, Record<string, never>, Scalars['DateTime'] | string>;
    default_cart_id?: GraphCacheResolver<WithTypename<Creator>, Record<string, never>, Scalars['String'] | string>;
    id?: GraphCacheResolver<WithTypename<Creator>, Record<string, never>, Scalars['ID'] | string>;
    is_approved?: GraphCacheResolver<WithTypename<Creator>, Record<string, never>, Scalars['Boolean'] | string>;
    phone_number?: GraphCacheResolver<WithTypename<Creator>, Record<string, never>, Scalars['String'] | string>;
    slug?: GraphCacheResolver<WithTypename<Creator>, Record<string, never>, Scalars['String'] | string>;
    socials?: GraphCacheResolver<WithTypename<Creator>, Record<string, never>, Array<WithTypename<SocialLink> | string>>;
    subscribers?: GraphCacheResolver<WithTypename<Creator>, CreatorSubscribersArgs, WithTypename<SubscriberConnection> | string>;
    updated_at?: GraphCacheResolver<WithTypename<Creator>, Record<string, never>, Scalars['DateTime'] | string>;
    user_id?: GraphCacheResolver<WithTypename<Creator>, Record<string, never>, Scalars['String'] | string>;
  };
  CreatorAnalytics?: {
    carts?: GraphCacheResolver<WithTypename<CreatorAnalytics>, CreatorAnalyticsCartsArgs, WithTypename<CartConnection> | string>;
    carts_analytics?: GraphCacheResolver<
      WithTypename<CreatorAnalytics>,
      CreatorAnalyticsCarts_AnalyticsArgs,
      WithTypename<CreatorCartAnalyticsConnection> | string
    >;
    charts_sales_failure?: GraphCacheResolver<
      WithTypename<CreatorAnalytics>,
      Record<string, never>,
      Array<WithTypename<CartSalesRow> | string>
    >;
    charts_sales_pending?: GraphCacheResolver<
      WithTypename<CreatorAnalytics>,
      Record<string, never>,
      Array<WithTypename<CartSalesRow> | string>
    >;
    charts_sales_success?: GraphCacheResolver<
      WithTypename<CreatorAnalytics>,
      Record<string, never>,
      Array<WithTypename<CartSalesRow> | string>
    >;
    charts_subscriptions?: GraphCacheResolver<
      WithTypename<CreatorAnalytics>,
      Record<string, never>,
      Array<WithTypename<ChartRow> | string>
    >;
    charts_unsubscriptions?: GraphCacheResolver<
      WithTypename<CreatorAnalytics>,
      Record<string, never>,
      Array<WithTypename<ChartRow> | string>
    >;
    creator?: GraphCacheResolver<WithTypename<CreatorAnalytics>, Record<string, never>, WithTypename<Creator> | string>;
    gross_sales?: GraphCacheResolver<WithTypename<CreatorAnalytics>, Record<string, never>, WithTypename<Price> | string>;
    sales_failure?: GraphCacheResolver<
      WithTypename<CreatorAnalytics>,
      CreatorAnalyticsSales_FailureArgs,
      WithTypename<BasketAnonymizedConnection> | string
    >;
    sales_pending?: GraphCacheResolver<
      WithTypename<CreatorAnalytics>,
      CreatorAnalyticsSales_PendingArgs,
      WithTypename<BasketAnonymizedConnection> | string
    >;
    sales_success?: GraphCacheResolver<
      WithTypename<CreatorAnalytics>,
      CreatorAnalyticsSales_SuccessArgs,
      WithTypename<BasketAnonymizedConnection> | string
    >;
    shops?: GraphCacheResolver<WithTypename<CreatorAnalytics>, CreatorAnalyticsShopsArgs, WithTypename<ShopConnection> | string>;
    shops_analytics?: GraphCacheResolver<
      WithTypename<CreatorAnalytics>,
      CreatorAnalyticsShops_AnalyticsArgs,
      WithTypename<ShopCreatorAnalyticsConnection> | string
    >;
    total_subscriptions?: GraphCacheResolver<WithTypename<CreatorAnalytics>, Record<string, never>, Scalars['Int'] | string>;
    total_unsubscriptions?: GraphCacheResolver<WithTypename<CreatorAnalytics>, Record<string, never>, Scalars['Int'] | string>;
  };
  CreatorCartAnalytics?: {
    cart?: GraphCacheResolver<WithTypename<CreatorCartAnalytics>, Record<string, never>, WithTypename<Cart> | string>;
    creator?: GraphCacheResolver<WithTypename<CreatorCartAnalytics>, Record<string, never>, WithTypename<Creator> | string>;
    gross_sales?: GraphCacheResolver<WithTypename<CreatorCartAnalytics>, Record<string, never>, WithTypename<Price> | string>;
    sales_success?: GraphCacheResolver<
      WithTypename<CreatorCartAnalytics>,
      CreatorCartAnalyticsSales_SuccessArgs,
      WithTypename<BasketAnonymizedConnection> | string
    >;
  };
  CreatorCartAnalyticsConnection?: {
    edges?: GraphCacheResolver<
      WithTypename<CreatorCartAnalyticsConnection>,
      Record<string, never>,
      Array<WithTypename<CreatorCartAnalyticsEdge> | string>
    >;
    pageInfo?: GraphCacheResolver<WithTypename<CreatorCartAnalyticsConnection>, Record<string, never>, WithTypename<PageInfo> | string>;
    totalCount?: GraphCacheResolver<WithTypename<CreatorCartAnalyticsConnection>, Record<string, never>, Scalars['Int'] | string>;
  };
  CreatorCartAnalyticsEdge?: {
    cursor?: GraphCacheResolver<WithTypename<CreatorCartAnalyticsEdge>, Record<string, never>, Scalars['String'] | string>;
    node?: GraphCacheResolver<WithTypename<CreatorCartAnalyticsEdge>, Record<string, never>, WithTypename<CreatorCartAnalytics> | string>;
  };
  CreatorConnection?: {
    edges?: GraphCacheResolver<WithTypename<CreatorConnection>, Record<string, never>, Array<WithTypename<CreatorEdge> | string>>;
    pageInfo?: GraphCacheResolver<WithTypename<CreatorConnection>, Record<string, never>, WithTypename<PageInfo> | string>;
    totalCount?: GraphCacheResolver<WithTypename<CreatorConnection>, Record<string, never>, Scalars['Int'] | string>;
  };
  CreatorEdge?: {
    cursor?: GraphCacheResolver<WithTypename<CreatorEdge>, Record<string, never>, Scalars['String'] | string>;
    node?: GraphCacheResolver<WithTypename<CreatorEdge>, Record<string, never>, WithTypename<Creator> | string>;
  };
  Geolocation?: {
    calling_code?: GraphCacheResolver<WithTypename<Geolocation>, Record<string, never>, Scalars['String'] | string>;
    city?: GraphCacheResolver<WithTypename<Geolocation>, Record<string, never>, Scalars['String'] | string>;
    country_code?: GraphCacheResolver<WithTypename<Geolocation>, Record<string, never>, Scalars['CountryCode'] | string>;
  };
  Image?: {
    alt?: GraphCacheResolver<WithTypename<Image>, Record<string, never>, Scalars['String'] | string>;
    url?: GraphCacheResolver<WithTypename<Image>, Record<string, never>, Scalars['AbsoluteUrl'] | string>;
  };
  ImageUploadOutput?: {
    signed_url?: GraphCacheResolver<WithTypename<ImageUploadOutput>, Record<string, never>, Scalars['AbsoluteUrl'] | string>;
    url?: GraphCacheResolver<WithTypename<ImageUploadOutput>, Record<string, never>, Scalars['AbsoluteUrl'] | string>;
  };
  Invoice?: {
    basket?: GraphCacheResolver<WithTypename<Invoice>, Record<string, never>, WithTypename<Basket> | string>;
    cart?: GraphCacheResolver<WithTypename<Invoice>, Record<string, never>, WithTypename<Cart> | string>;
  };
  LiteAnalytics?: {
    metrics?: GraphCacheResolver<WithTypename<LiteAnalytics>, Record<string, never>, WithTypename<LiteAnalyticsMetrics> | string>;
    productLinkStats?: GraphCacheResolver<
      WithTypename<LiteAnalytics>,
      Record<string, never>,
      Array<WithTypename<LiteProductLinkStats> | string>
    >;
    subscriptions?: GraphCacheResolver<WithTypename<LiteAnalytics>, Record<string, never>, Array<Scalars['String'] | string>>;
  };
  LiteAnalyticsMetrics?: {
    campaigns?: GraphCacheResolver<WithTypename<LiteAnalyticsMetrics>, Record<string, never>, Scalars['String'] | string>;
    productLinkVisits?: GraphCacheResolver<WithTypename<LiteAnalyticsMetrics>, Record<string, never>, Scalars['String'] | string>;
    subscriptions?: GraphCacheResolver<WithTypename<LiteAnalyticsMetrics>, Record<string, never>, Scalars['String'] | string>;
    visits?: GraphCacheResolver<WithTypename<LiteAnalyticsMetrics>, Record<string, never>, Scalars['String'] | string>;
  };
  LiteCampaign?: {
    creator?: GraphCacheResolver<WithTypename<LiteCampaign>, Record<string, never>, WithTypename<Creator> | string>;
    creator_id?: GraphCacheResolver<WithTypename<LiteCampaign>, Record<string, never>, Scalars['String'] | string>;
    id?: GraphCacheResolver<WithTypename<LiteCampaign>, Record<string, never>, Scalars['ID'] | string>;
    links?: GraphCacheResolver<WithTypename<LiteCampaign>, Record<string, never>, Array<WithTypename<ProductLink> | string>>;
    shop_id?: GraphCacheResolver<WithTypename<LiteCampaign>, Record<string, never>, Scalars['String'] | string>;
    slug?: GraphCacheResolver<WithTypename<LiteCampaign>, Record<string, never>, Scalars['String'] | string>;
  };
  LiteCampaignConnection?: {
    edges?: GraphCacheResolver<WithTypename<LiteCampaignConnection>, Record<string, never>, Array<WithTypename<LiteCampaignEdge> | string>>;
    pageInfo?: GraphCacheResolver<WithTypename<LiteCampaignConnection>, Record<string, never>, WithTypename<PageInfo> | string>;
    totalCount?: GraphCacheResolver<WithTypename<LiteCampaignConnection>, Record<string, never>, Scalars['Int'] | string>;
  };
  LiteCampaignEdge?: {
    cursor?: GraphCacheResolver<WithTypename<LiteCampaignEdge>, Record<string, never>, Scalars['String'] | string>;
    node?: GraphCacheResolver<WithTypename<LiteCampaignEdge>, Record<string, never>, WithTypename<LiteCampaign> | string>;
  };
  LiteConversion?: {
    action?: GraphCacheResolver<WithTypename<LiteConversion>, Record<string, never>, Scalars['String'] | string>;
    campaign?: GraphCacheResolver<WithTypename<LiteConversion>, Record<string, never>, Scalars['ID'] | string>;
    ip?: GraphCacheResolver<WithTypename<LiteConversion>, Record<string, never>, Scalars['String'] | string>;
    phoneNumber?: GraphCacheResolver<WithTypename<LiteConversion>, Record<string, never>, Scalars['String'] | string>;
    referrer?: GraphCacheResolver<WithTypename<LiteConversion>, Record<string, never>, Scalars['String'] | string>;
    userAgent?: GraphCacheResolver<WithTypename<LiteConversion>, Record<string, never>, Scalars['String'] | string>;
  };
  LiteProductLinkStats?: {
    slug?: GraphCacheResolver<WithTypename<LiteProductLinkStats>, Record<string, never>, Scalars['String'] | string>;
    visits?: GraphCacheResolver<WithTypename<LiteProductLinkStats>, Record<string, never>, Scalars['String'] | string>;
  };
  PageInfo?: {
    endCursor?: GraphCacheResolver<WithTypename<PageInfo>, Record<string, never>, Scalars['String'] | string>;
    hasNextPage?: GraphCacheResolver<WithTypename<PageInfo>, Record<string, never>, Scalars['Boolean'] | string>;
    hasPreviousPage?: GraphCacheResolver<WithTypename<PageInfo>, Record<string, never>, Scalars['Boolean'] | string>;
    startCursor?: GraphCacheResolver<WithTypename<PageInfo>, Record<string, never>, Scalars['String'] | string>;
  };
  PaymentGateway?: {
    auth_modes?: GraphCacheResolver<
      WithTypename<PaymentGateway>,
      Record<string, never>,
      Array<WithTypename<PaymentGatewayAuthMode> | string>
    >;
    gateway_type?: GraphCacheResolver<WithTypename<PaymentGateway>, Record<string, never>, Scalars['String'] | string>;
    name?: GraphCacheResolver<WithTypename<PaymentGateway>, Record<string, never>, Scalars['String'] | string>;
    payment_methods?: GraphCacheResolver<WithTypename<PaymentGateway>, Record<string, never>, Array<Scalars['String'] | string>>;
    supported_countries?: GraphCacheResolver<WithTypename<PaymentGateway>, Record<string, never>, Array<Scalars['CountryCode'] | string>>;
  };
  PaymentGatewayAuthMode?: {
    auth_mode_type?: GraphCacheResolver<WithTypename<PaymentGatewayAuthMode>, Record<string, never>, Scalars['String'] | string>;
    credentials?: GraphCacheResolver<
      WithTypename<PaymentGatewayAuthMode>,
      Record<string, never>,
      Array<WithTypename<PaymentGatewayCredential> | string>
    >;
    name?: GraphCacheResolver<WithTypename<PaymentGatewayAuthMode>, Record<string, never>, Scalars['String'] | string>;
  };
  PaymentGatewayCredential?: {
    label?: GraphCacheResolver<WithTypename<PaymentGatewayCredential>, Record<string, never>, Scalars['String'] | string>;
    name?: GraphCacheResolver<WithTypename<PaymentGatewayCredential>, Record<string, never>, Scalars['String'] | string>;
    safe?: GraphCacheResolver<WithTypename<PaymentGatewayCredential>, Record<string, never>, Scalars['Boolean'] | string>;
  };
  PaymentMethod?: {
    billing_details?: GraphCacheResolver<
      WithTypename<PaymentMethod>,
      Record<string, never>,
      WithTypename<PaymentMethodBillingDetails> | string
    >;
    card?: GraphCacheResolver<WithTypename<PaymentMethod>, Record<string, never>, WithTypename<PaymentMethodCard> | string>;
    id?: GraphCacheResolver<WithTypename<PaymentMethod>, Record<string, never>, Scalars['ID'] | string>;
    type?: GraphCacheResolver<WithTypename<PaymentMethod>, Record<string, never>, Scalars['String'] | string>;
  };
  PaymentMethodBillingDetails?: {
    address?: GraphCacheResolver<WithTypename<PaymentMethodBillingDetails>, Record<string, never>, WithTypename<Address> | string>;
    email?: GraphCacheResolver<WithTypename<PaymentMethodBillingDetails>, Record<string, never>, Scalars['EmailAddress'] | string>;
    name?: GraphCacheResolver<WithTypename<PaymentMethodBillingDetails>, Record<string, never>, Scalars['String'] | string>;
    phone?: GraphCacheResolver<WithTypename<PaymentMethodBillingDetails>, Record<string, never>, Scalars['PhoneNumber'] | string>;
  };
  PaymentMethodCard?: {
    brand?: GraphCacheResolver<WithTypename<PaymentMethodCard>, Record<string, never>, Scalars['String'] | string>;
    country?: GraphCacheResolver<WithTypename<PaymentMethodCard>, Record<string, never>, Scalars['String'] | string>;
    exp_month?: GraphCacheResolver<WithTypename<PaymentMethodCard>, Record<string, never>, Scalars['Int'] | string>;
    exp_year?: GraphCacheResolver<WithTypename<PaymentMethodCard>, Record<string, never>, Scalars['Int'] | string>;
    last4?: GraphCacheResolver<WithTypename<PaymentMethodCard>, Record<string, never>, Scalars['String'] | string>;
  };
  PaymentProvider?: {
    accepted_card_brands?: GraphCacheResolver<WithTypename<PaymentProvider>, Record<string, never>, Array<Scalars['String'] | string>>;
    config?: GraphCacheResolver<WithTypename<PaymentProvider>, Record<string, never>, WithTypename<PaymentProviderConfig> | string>;
    gateway_type?: GraphCacheResolver<WithTypename<PaymentProvider>, Record<string, never>, Scalars['String'] | string>;
    id?: GraphCacheResolver<WithTypename<PaymentProvider>, Record<string, never>, Scalars['ID'] | string>;
    type?: GraphCacheResolver<WithTypename<PaymentProvider>, Record<string, never>, Scalars['String'] | string>;
  };
  PaymentProviderShopifyConfig?: {
    card_vault_url?: GraphCacheResolver<WithTypename<PaymentProviderShopifyConfig>, Record<string, never>, Scalars['String'] | string>;
    shopify_payments_account_id?: GraphCacheResolver<
      WithTypename<PaymentProviderShopifyConfig>,
      Record<string, never>,
      Scalars['String'] | string
    >;
  };
  PaymentProviderSpreedlyConfig?: {
    enable_3ds?: GraphCacheResolver<WithTypename<PaymentProviderSpreedlyConfig>, Record<string, never>, Scalars['Boolean'] | string>;
    environment_key?: GraphCacheResolver<WithTypename<PaymentProviderSpreedlyConfig>, Record<string, never>, Scalars['String'] | string>;
    gateway_token?: GraphCacheResolver<WithTypename<PaymentProviderSpreedlyConfig>, Record<string, never>, Scalars['String'] | string>;
    sandbox?: GraphCacheResolver<WithTypename<PaymentProviderSpreedlyConfig>, Record<string, never>, Scalars['String'] | string>;
  };
  PhoneNumberDetails?: {
    country?: GraphCacheResolver<WithTypename<PhoneNumberDetails>, Record<string, never>, Scalars['CountryCode'] | string>;
    phone_number?: GraphCacheResolver<WithTypename<PhoneNumberDetails>, Record<string, never>, Scalars['PhoneNumber'] | string>;
    region?: GraphCacheResolver<WithTypename<PhoneNumberDetails>, Record<string, never>, Scalars['String'] | string>;
  };
  Price?: {
    amount?: GraphCacheResolver<WithTypename<Price>, Record<string, never>, Scalars['Int'] | string>;
    currency?: GraphCacheResolver<WithTypename<Price>, Record<string, never>, Scalars['String'] | string>;
    old_amount?: GraphCacheResolver<WithTypename<Price>, Record<string, never>, Scalars['Int'] | string>;
  };
  Product?: {
    description?: GraphCacheResolver<WithTypename<Product>, Record<string, never>, Scalars['String'] | string>;
    id?: GraphCacheResolver<WithTypename<Product>, Record<string, never>, Scalars['ID'] | string>;
    images?: GraphCacheResolver<WithTypename<Product>, Record<string, never>, Array<WithTypename<Image> | string>>;
    name?: GraphCacheResolver<WithTypename<Product>, Record<string, never>, Scalars['String'] | string>;
    options?: GraphCacheResolver<WithTypename<Product>, Record<string, never>, Array<WithTypename<ProductOption> | string>>;
    variants?: GraphCacheResolver<WithTypename<Product>, Record<string, never>, Array<WithTypename<ProductVariant> | string>>;
  };
  ProductCatalog?: {
    description?: GraphCacheResolver<WithTypename<ProductCatalog>, Record<string, never>, Scalars['String'] | string>;
    id?: GraphCacheResolver<WithTypename<ProductCatalog>, Record<string, never>, Scalars['ID'] | string>;
    title?: GraphCacheResolver<WithTypename<ProductCatalog>, Record<string, never>, Scalars['String'] | string>;
  };
  ProductCatalogConnection?: {
    edges?: GraphCacheResolver<
      WithTypename<ProductCatalogConnection>,
      Record<string, never>,
      Array<WithTypename<ProductCatalogEdge> | string>
    >;
    pageInfo?: GraphCacheResolver<WithTypename<ProductCatalogConnection>, Record<string, never>, WithTypename<PageInfo> | string>;
    totalCount?: GraphCacheResolver<WithTypename<ProductCatalogConnection>, Record<string, never>, Scalars['Int'] | string>;
  };
  ProductCatalogEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ProductCatalogEdge>, Record<string, never>, Scalars['String'] | string>;
    node?: GraphCacheResolver<WithTypename<ProductCatalogEdge>, Record<string, never>, WithTypename<ProductCatalog> | string>;
  };
  ProductCollection?: {
    catalog_id?: GraphCacheResolver<WithTypename<ProductCollection>, Record<string, never>, Scalars['ID'] | string>;
    description?: GraphCacheResolver<WithTypename<ProductCollection>, Record<string, never>, Scalars['String'] | string>;
    id?: GraphCacheResolver<WithTypename<ProductCollection>, Record<string, never>, Scalars['ID'] | string>;
    title?: GraphCacheResolver<WithTypename<ProductCollection>, Record<string, never>, Scalars['String'] | string>;
  };
  ProductCollectionConnection?: {
    edges?: GraphCacheResolver<
      WithTypename<ProductCollectionConnection>,
      Record<string, never>,
      Array<WithTypename<ProductCollectionEdge> | string>
    >;
    pageInfo?: GraphCacheResolver<WithTypename<ProductCollectionConnection>, Record<string, never>, WithTypename<PageInfo> | string>;
    totalCount?: GraphCacheResolver<WithTypename<ProductCollectionConnection>, Record<string, never>, Scalars['Int'] | string>;
  };
  ProductCollectionEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ProductCollectionEdge>, Record<string, never>, Scalars['String'] | string>;
    node?: GraphCacheResolver<WithTypename<ProductCollectionEdge>, Record<string, never>, WithTypename<ProductCollection> | string>;
  };
  ProductConnection?: {
    edges?: GraphCacheResolver<WithTypename<ProductConnection>, Record<string, never>, Array<WithTypename<ProductEdge> | string>>;
    pageInfo?: GraphCacheResolver<WithTypename<ProductConnection>, Record<string, never>, WithTypename<PageInfo> | string>;
    totalCount?: GraphCacheResolver<WithTypename<ProductConnection>, Record<string, never>, Scalars['Int'] | string>;
  };
  ProductEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ProductEdge>, Record<string, never>, Scalars['String'] | string>;
    node?: GraphCacheResolver<WithTypename<ProductEdge>, Record<string, never>, WithTypename<Product> | string>;
  };
  ProductLink?: {
    link?: GraphCacheResolver<WithTypename<ProductLink>, Record<string, never>, Scalars['String'] | string>;
    slug?: GraphCacheResolver<WithTypename<ProductLink>, Record<string, never>, Scalars['String'] | string>;
  };
  ProductOption?: {
    choices?: GraphCacheResolver<WithTypename<ProductOption>, Record<string, never>, Array<WithTypename<ProductOptionChoice> | string>>;
    label?: GraphCacheResolver<WithTypename<ProductOption>, Record<string, never>, Scalars['String'] | string>;
    type?: GraphCacheResolver<WithTypename<ProductOption>, Record<string, never>, ProductOptionType | string>;
    value?: GraphCacheResolver<WithTypename<ProductOption>, Record<string, never>, Scalars['String'] | string>;
  };
  ProductOptionChoice?: {
    image?: GraphCacheResolver<WithTypename<ProductOptionChoice>, Record<string, never>, WithTypename<Image> | string>;
    label?: GraphCacheResolver<WithTypename<ProductOptionChoice>, Record<string, never>, Scalars['String'] | string>;
    value?: GraphCacheResolver<WithTypename<ProductOptionChoice>, Record<string, never>, Scalars['String'] | string>;
  };
  ProductOverride?: {
    description?: GraphCacheResolver<WithTypename<ProductOverride>, Record<string, never>, Scalars['String'] | string>;
    id?: GraphCacheResolver<WithTypename<ProductOverride>, Record<string, never>, Scalars['ID'] | string>;
    name?: GraphCacheResolver<WithTypename<ProductOverride>, Record<string, never>, Scalars['String'] | string>;
    price_amount?: GraphCacheResolver<WithTypename<ProductOverride>, Record<string, never>, Scalars['Int'] | string>;
  };
  ProductVariant?: {
    description?: GraphCacheResolver<WithTypename<ProductVariant>, Record<string, never>, Scalars['String'] | string>;
    id?: GraphCacheResolver<WithTypename<ProductVariant>, Record<string, never>, Scalars['ID'] | string>;
    images?: GraphCacheResolver<WithTypename<ProductVariant>, Record<string, never>, Array<WithTypename<Image> | string>>;
    name?: GraphCacheResolver<WithTypename<ProductVariant>, Record<string, never>, Scalars['String'] | string>;
    price?: GraphCacheResolver<WithTypename<ProductVariant>, ProductVariantPriceArgs, WithTypename<Price> | string>;
    prices?: GraphCacheResolver<WithTypename<ProductVariant>, Record<string, never>, Array<WithTypename<Price> | string>>;
    sku?: GraphCacheResolver<WithTypename<ProductVariant>, Record<string, never>, Scalars['String'] | string>;
    soldOut?: GraphCacheResolver<WithTypename<ProductVariant>, Record<string, never>, Scalars['Boolean'] | string>;
    variations?: GraphCacheResolver<WithTypename<ProductVariant>, Record<string, never>, Scalars['JSONObject'] | string>;
  };
  Reservation?: {
    created_at?: GraphCacheResolver<WithTypename<Reservation>, Record<string, never>, Scalars['DateTime'] | string>;
    id?: GraphCacheResolver<WithTypename<Reservation>, Record<string, never>, Scalars['ID'] | string>;
    phone_number?: GraphCacheResolver<WithTypename<Reservation>, Record<string, never>, Scalars['String'] | string>;
    slug?: GraphCacheResolver<WithTypename<Reservation>, Record<string, never>, Scalars['String'] | string>;
    updated_at?: GraphCacheResolver<WithTypename<Reservation>, Record<string, never>, Scalars['DateTime'] | string>;
  };
  ShopAnalytics?: {
    carts?: GraphCacheResolver<WithTypename<ShopAnalytics>, ShopAnalyticsCartsArgs, WithTypename<CartConnection> | string>;
    carts_analytics?: GraphCacheResolver<
      WithTypename<ShopAnalytics>,
      ShopAnalyticsCarts_AnalyticsArgs,
      WithTypename<ShopCartAnalyticsConnection> | string
    >;
    charts_sales_failure?: GraphCacheResolver<
      WithTypename<ShopAnalytics>,
      Record<string, never>,
      Array<WithTypename<CartSalesRow> | string>
    >;
    charts_sales_pending?: GraphCacheResolver<
      WithTypename<ShopAnalytics>,
      Record<string, never>,
      Array<WithTypename<CartSalesRow> | string>
    >;
    charts_sales_success?: GraphCacheResolver<
      WithTypename<ShopAnalytics>,
      Record<string, never>,
      Array<WithTypename<CartSalesRow> | string>
    >;
    charts_subscriptions?: GraphCacheResolver<WithTypename<ShopAnalytics>, Record<string, never>, Array<WithTypename<ChartRow> | string>>;
    charts_unsubscriptions?: GraphCacheResolver<WithTypename<ShopAnalytics>, Record<string, never>, Array<WithTypename<ChartRow> | string>>;
    creators?: GraphCacheResolver<WithTypename<ShopAnalytics>, ShopAnalyticsCreatorsArgs, WithTypename<CreatorConnection> | string>;
    creators_analytics?: GraphCacheResolver<
      WithTypename<ShopAnalytics>,
      ShopAnalyticsCreators_AnalyticsArgs,
      WithTypename<ShopCreatorAnalyticsConnection> | string
    >;
    gross_sales?: GraphCacheResolver<WithTypename<ShopAnalytics>, Record<string, never>, WithTypename<Price> | string>;
    sales_failure?: GraphCacheResolver<
      WithTypename<ShopAnalytics>,
      ShopAnalyticsSales_FailureArgs,
      WithTypename<BasketAnonymizedConnection> | string
    >;
    sales_pending?: GraphCacheResolver<
      WithTypename<ShopAnalytics>,
      ShopAnalyticsSales_PendingArgs,
      WithTypename<BasketAnonymizedConnection> | string
    >;
    sales_success?: GraphCacheResolver<
      WithTypename<ShopAnalytics>,
      ShopAnalyticsSales_SuccessArgs,
      WithTypename<BasketAnonymizedConnection> | string
    >;
    shop?: GraphCacheResolver<
      WithTypename<ShopAnalytics>,
      Record<string, never>,
      | WithTypename<ShopBrand>
      | WithTypename<ShopNative>
      | WithTypename<ShopSfcc>
      | WithTypename<ShopShopify>
      | WithTypename<ShopShopifyNative>
      | string
    >;
    total_creators_subscriptions?: GraphCacheResolver<WithTypename<ShopAnalytics>, Record<string, never>, Scalars['Int'] | string>;
    total_creators_unsubscriptions?: GraphCacheResolver<WithTypename<ShopAnalytics>, Record<string, never>, Scalars['Int'] | string>;
  };
  ShopBrand?: {
    avatar?: GraphCacheResolver<WithTypename<ShopBrand>, Record<string, never>, Scalars['AbsoluteUrl'] | string>;
    carts?: GraphCacheResolver<WithTypename<ShopBrand>, ShopBrandCartsArgs, WithTypename<CartConnection> | string>;
    catalogs?: GraphCacheResolver<WithTypename<ShopBrand>, ShopBrandCatalogsArgs, WithTypename<ProductCatalogConnection> | string>;
    collections?: GraphCacheResolver<WithTypename<ShopBrand>, ShopBrandCollectionsArgs, WithTypename<ProductCollectionConnection> | string>;
    created_at?: GraphCacheResolver<WithTypename<ShopBrand>, Record<string, never>, Scalars['DateTime'] | string>;
    creators?: GraphCacheResolver<WithTypename<ShopBrand>, ShopBrandCreatorsArgs, WithTypename<CreatorConnection> | string>;
    default_country_code?: GraphCacheResolver<WithTypename<ShopBrand>, Record<string, never>, Scalars['String'] | string>;
    default_currency?: GraphCacheResolver<WithTypename<ShopBrand>, Record<string, never>, Scalars['String'] | string>;
    display_name?: GraphCacheResolver<WithTypename<ShopBrand>, Record<string, never>, Scalars['String'] | string>;
    id?: GraphCacheResolver<WithTypename<ShopBrand>, Record<string, never>, Scalars['ID'] | string>;
    name?: GraphCacheResolver<WithTypename<ShopBrand>, Record<string, never>, Scalars['String'] | string>;
    production_date?: GraphCacheResolver<WithTypename<ShopBrand>, Record<string, never>, Scalars['DateTime'] | string>;
    products?: GraphCacheResolver<WithTypename<ShopBrand>, ShopBrandProductsArgs, WithTypename<ProductConnection> | string>;
    provider?: GraphCacheResolver<WithTypename<ShopBrand>, Record<string, never>, ShopProvider | string>;
    updated_at?: GraphCacheResolver<WithTypename<ShopBrand>, Record<string, never>, Scalars['DateTime'] | string>;
  };
  ShopCartAnalytics?: {
    cart?: GraphCacheResolver<WithTypename<ShopCartAnalytics>, Record<string, never>, WithTypename<Cart> | string>;
    gross_sales?: GraphCacheResolver<WithTypename<ShopCartAnalytics>, Record<string, never>, WithTypename<Price> | string>;
    sales_success?: GraphCacheResolver<
      WithTypename<ShopCartAnalytics>,
      ShopCartAnalyticsSales_SuccessArgs,
      WithTypename<BasketAnonymizedConnection> | string
    >;
    shop?: GraphCacheResolver<
      WithTypename<ShopCartAnalytics>,
      Record<string, never>,
      | WithTypename<ShopBrand>
      | WithTypename<ShopNative>
      | WithTypename<ShopSfcc>
      | WithTypename<ShopShopify>
      | WithTypename<ShopShopifyNative>
      | string
    >;
  };
  ShopCartAnalyticsConnection?: {
    edges?: GraphCacheResolver<
      WithTypename<ShopCartAnalyticsConnection>,
      Record<string, never>,
      Array<WithTypename<ShopCartAnalyticsEdge> | string>
    >;
    pageInfo?: GraphCacheResolver<WithTypename<ShopCartAnalyticsConnection>, Record<string, never>, WithTypename<PageInfo> | string>;
    totalCount?: GraphCacheResolver<WithTypename<ShopCartAnalyticsConnection>, Record<string, never>, Scalars['Int'] | string>;
  };
  ShopCartAnalyticsEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ShopCartAnalyticsEdge>, Record<string, never>, Scalars['String'] | string>;
    node?: GraphCacheResolver<WithTypename<ShopCartAnalyticsEdge>, Record<string, never>, WithTypename<ShopCartAnalytics> | string>;
  };
  ShopConnection?: {
    edges?: GraphCacheResolver<WithTypename<ShopConnection>, Record<string, never>, Array<WithTypename<ShopEdge> | string>>;
    pageInfo?: GraphCacheResolver<WithTypename<ShopConnection>, Record<string, never>, WithTypename<PageInfo> | string>;
    totalCount?: GraphCacheResolver<WithTypename<ShopConnection>, Record<string, never>, Scalars['Int'] | string>;
  };
  ShopCreateShopifyOutput?: {
    redirect_to?: GraphCacheResolver<WithTypename<ShopCreateShopifyOutput>, Record<string, never>, Scalars['AbsoluteUrl'] | string>;
  };
  ShopCreatorAnalytics?: {
    creator?: GraphCacheResolver<WithTypename<ShopCreatorAnalytics>, Record<string, never>, WithTypename<Creator> | string>;
    gross_sales?: GraphCacheResolver<WithTypename<ShopCreatorAnalytics>, Record<string, never>, WithTypename<Price> | string>;
    sales_success?: GraphCacheResolver<
      WithTypename<ShopCreatorAnalytics>,
      ShopCreatorAnalyticsSales_SuccessArgs,
      WithTypename<BasketAnonymizedConnection> | string
    >;
    shop?: GraphCacheResolver<
      WithTypename<ShopCreatorAnalytics>,
      Record<string, never>,
      | WithTypename<ShopBrand>
      | WithTypename<ShopNative>
      | WithTypename<ShopSfcc>
      | WithTypename<ShopShopify>
      | WithTypename<ShopShopifyNative>
      | string
    >;
    total_subscriptions?: GraphCacheResolver<WithTypename<ShopCreatorAnalytics>, Record<string, never>, Scalars['Int'] | string>;
    total_unsubscriptions?: GraphCacheResolver<WithTypename<ShopCreatorAnalytics>, Record<string, never>, Scalars['Int'] | string>;
  };
  ShopCreatorAnalyticsConnection?: {
    edges?: GraphCacheResolver<
      WithTypename<ShopCreatorAnalyticsConnection>,
      Record<string, never>,
      Array<WithTypename<ShopCreatorAnalyticsEdge> | string>
    >;
    pageInfo?: GraphCacheResolver<WithTypename<ShopCreatorAnalyticsConnection>, Record<string, never>, WithTypename<PageInfo> | string>;
    totalCount?: GraphCacheResolver<WithTypename<ShopCreatorAnalyticsConnection>, Record<string, never>, Scalars['Int'] | string>;
  };
  ShopCreatorAnalyticsEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ShopCreatorAnalyticsEdge>, Record<string, never>, Scalars['String'] | string>;
    node?: GraphCacheResolver<WithTypename<ShopCreatorAnalyticsEdge>, Record<string, never>, WithTypename<ShopCreatorAnalytics> | string>;
  };
  ShopEdge?: {
    cursor?: GraphCacheResolver<WithTypename<ShopEdge>, Record<string, never>, Scalars['String'] | string>;
    node?: GraphCacheResolver<
      WithTypename<ShopEdge>,
      Record<string, never>,
      | WithTypename<ShopBrand>
      | WithTypename<ShopNative>
      | WithTypename<ShopSfcc>
      | WithTypename<ShopShopify>
      | WithTypename<ShopShopifyNative>
      | string
    >;
  };
  ShopNative?: {
    avatar?: GraphCacheResolver<WithTypename<ShopNative>, Record<string, never>, Scalars['AbsoluteUrl'] | string>;
    carts?: GraphCacheResolver<WithTypename<ShopNative>, ShopNativeCartsArgs, WithTypename<CartConnection> | string>;
    catalogs?: GraphCacheResolver<WithTypename<ShopNative>, ShopNativeCatalogsArgs, WithTypename<ProductCatalogConnection> | string>;
    collections?: GraphCacheResolver<
      WithTypename<ShopNative>,
      ShopNativeCollectionsArgs,
      WithTypename<ProductCollectionConnection> | string
    >;
    created_at?: GraphCacheResolver<WithTypename<ShopNative>, Record<string, never>, Scalars['DateTime'] | string>;
    creators?: GraphCacheResolver<WithTypename<ShopNative>, ShopNativeCreatorsArgs, WithTypename<CreatorConnection> | string>;
    default_country_code?: GraphCacheResolver<WithTypename<ShopNative>, Record<string, never>, Scalars['String'] | string>;
    default_currency?: GraphCacheResolver<WithTypename<ShopNative>, Record<string, never>, Scalars['String'] | string>;
    display_name?: GraphCacheResolver<WithTypename<ShopNative>, Record<string, never>, Scalars['String'] | string>;
    id?: GraphCacheResolver<WithTypename<ShopNative>, Record<string, never>, Scalars['ID'] | string>;
    name?: GraphCacheResolver<WithTypename<ShopNative>, Record<string, never>, Scalars['String'] | string>;
    production_date?: GraphCacheResolver<WithTypename<ShopNative>, Record<string, never>, Scalars['DateTime'] | string>;
    products?: GraphCacheResolver<WithTypename<ShopNative>, ShopNativeProductsArgs, WithTypename<ProductConnection> | string>;
    provider?: GraphCacheResolver<WithTypename<ShopNative>, Record<string, never>, ShopProvider | string>;
    updated_at?: GraphCacheResolver<WithTypename<ShopNative>, Record<string, never>, Scalars['DateTime'] | string>;
  };
  ShopSFCC?: {
    avatar?: GraphCacheResolver<WithTypename<ShopSfcc>, Record<string, never>, Scalars['AbsoluteUrl'] | string>;
    carts?: GraphCacheResolver<WithTypename<ShopSfcc>, ShopSfccCartsArgs, WithTypename<CartConnection> | string>;
    catalogs?: GraphCacheResolver<WithTypename<ShopSfcc>, ShopSfccCatalogsArgs, WithTypename<ProductCatalogConnection> | string>;
    collections?: GraphCacheResolver<WithTypename<ShopSfcc>, ShopSfccCollectionsArgs, WithTypename<ProductCollectionConnection> | string>;
    created_at?: GraphCacheResolver<WithTypename<ShopSfcc>, Record<string, never>, Scalars['DateTime'] | string>;
    creators?: GraphCacheResolver<WithTypename<ShopSfcc>, ShopSfccCreatorsArgs, WithTypename<CreatorConnection> | string>;
    default_country_code?: GraphCacheResolver<WithTypename<ShopSfcc>, Record<string, never>, Scalars['String'] | string>;
    default_currency?: GraphCacheResolver<WithTypename<ShopSfcc>, Record<string, never>, Scalars['String'] | string>;
    display_name?: GraphCacheResolver<WithTypename<ShopSfcc>, Record<string, never>, Scalars['String'] | string>;
    id?: GraphCacheResolver<WithTypename<ShopSfcc>, Record<string, never>, Scalars['ID'] | string>;
    name?: GraphCacheResolver<WithTypename<ShopSfcc>, Record<string, never>, Scalars['String'] | string>;
    production_date?: GraphCacheResolver<WithTypename<ShopSfcc>, Record<string, never>, Scalars['DateTime'] | string>;
    products?: GraphCacheResolver<WithTypename<ShopSfcc>, ShopSfccProductsArgs, WithTypename<ProductConnection> | string>;
    provider?: GraphCacheResolver<WithTypename<ShopSfcc>, Record<string, never>, ShopProvider | string>;
    updated_at?: GraphCacheResolver<WithTypename<ShopSfcc>, Record<string, never>, Scalars['DateTime'] | string>;
  };
  ShopShopify?: {
    avatar?: GraphCacheResolver<WithTypename<ShopShopify>, Record<string, never>, Scalars['AbsoluteUrl'] | string>;
    carts?: GraphCacheResolver<WithTypename<ShopShopify>, ShopShopifyCartsArgs, WithTypename<CartConnection> | string>;
    catalogs?: GraphCacheResolver<WithTypename<ShopShopify>, ShopShopifyCatalogsArgs, WithTypename<ProductCatalogConnection> | string>;
    collections?: GraphCacheResolver<
      WithTypename<ShopShopify>,
      ShopShopifyCollectionsArgs,
      WithTypename<ProductCollectionConnection> | string
    >;
    created_at?: GraphCacheResolver<WithTypename<ShopShopify>, Record<string, never>, Scalars['DateTime'] | string>;
    creators?: GraphCacheResolver<WithTypename<ShopShopify>, ShopShopifyCreatorsArgs, WithTypename<CreatorConnection> | string>;
    default_country_code?: GraphCacheResolver<WithTypename<ShopShopify>, Record<string, never>, Scalars['String'] | string>;
    default_currency?: GraphCacheResolver<WithTypename<ShopShopify>, Record<string, never>, Scalars['String'] | string>;
    display_name?: GraphCacheResolver<WithTypename<ShopShopify>, Record<string, never>, Scalars['String'] | string>;
    id?: GraphCacheResolver<WithTypename<ShopShopify>, Record<string, never>, Scalars['ID'] | string>;
    name?: GraphCacheResolver<WithTypename<ShopShopify>, Record<string, never>, Scalars['String'] | string>;
    production_date?: GraphCacheResolver<WithTypename<ShopShopify>, Record<string, never>, Scalars['DateTime'] | string>;
    products?: GraphCacheResolver<WithTypename<ShopShopify>, ShopShopifyProductsArgs, WithTypename<ProductConnection> | string>;
    provider?: GraphCacheResolver<WithTypename<ShopShopify>, Record<string, never>, ShopProvider | string>;
    updated_at?: GraphCacheResolver<WithTypename<ShopShopify>, Record<string, never>, Scalars['DateTime'] | string>;
  };
  ShopShopifyNative?: {
    avatar?: GraphCacheResolver<WithTypename<ShopShopifyNative>, Record<string, never>, Scalars['AbsoluteUrl'] | string>;
    carts?: GraphCacheResolver<WithTypename<ShopShopifyNative>, ShopShopifyNativeCartsArgs, WithTypename<CartConnection> | string>;
    catalogs?: GraphCacheResolver<
      WithTypename<ShopShopifyNative>,
      ShopShopifyNativeCatalogsArgs,
      WithTypename<ProductCatalogConnection> | string
    >;
    collections?: GraphCacheResolver<
      WithTypename<ShopShopifyNative>,
      ShopShopifyNativeCollectionsArgs,
      WithTypename<ProductCollectionConnection> | string
    >;
    created_at?: GraphCacheResolver<WithTypename<ShopShopifyNative>, Record<string, never>, Scalars['DateTime'] | string>;
    creators?: GraphCacheResolver<WithTypename<ShopShopifyNative>, ShopShopifyNativeCreatorsArgs, WithTypename<CreatorConnection> | string>;
    default_country_code?: GraphCacheResolver<WithTypename<ShopShopifyNative>, Record<string, never>, Scalars['String'] | string>;
    default_currency?: GraphCacheResolver<WithTypename<ShopShopifyNative>, Record<string, never>, Scalars['String'] | string>;
    display_name?: GraphCacheResolver<WithTypename<ShopShopifyNative>, Record<string, never>, Scalars['String'] | string>;
    id?: GraphCacheResolver<WithTypename<ShopShopifyNative>, Record<string, never>, Scalars['ID'] | string>;
    name?: GraphCacheResolver<WithTypename<ShopShopifyNative>, Record<string, never>, Scalars['String'] | string>;
    production_date?: GraphCacheResolver<WithTypename<ShopShopifyNative>, Record<string, never>, Scalars['DateTime'] | string>;
    products?: GraphCacheResolver<WithTypename<ShopShopifyNative>, ShopShopifyNativeProductsArgs, WithTypename<ProductConnection> | string>;
    provider?: GraphCacheResolver<WithTypename<ShopShopifyNative>, Record<string, never>, ShopProvider | string>;
    updated_at?: GraphCacheResolver<WithTypename<ShopShopifyNative>, Record<string, never>, Scalars['DateTime'] | string>;
  };
  SocialLink?: {
    full_url?: GraphCacheResolver<WithTypename<SocialLink>, Record<string, never>, Scalars['AbsoluteUrl'] | string>;
    handle?: GraphCacheResolver<WithTypename<SocialLink>, Record<string, never>, Scalars['String'] | string>;
    type?: GraphCacheResolver<WithTypename<SocialLink>, Record<string, never>, SocialLinkType | string>;
  };
  Subscriber?: {
    created_at?: GraphCacheResolver<WithTypename<Subscriber>, Record<string, never>, Scalars['DateTime'] | string>;
    creator_id?: GraphCacheResolver<WithTypename<Subscriber>, Record<string, never>, Scalars['ID'] | string>;
    data?: GraphCacheResolver<WithTypename<Subscriber>, Record<string, never>, Scalars['JSON'] | string>;
    is_subscribed?: GraphCacheResolver<WithTypename<Subscriber>, Record<string, never>, Scalars['Boolean'] | string>;
    phone_number?: GraphCacheResolver<WithTypename<Subscriber>, Record<string, never>, Scalars['String'] | string>;
    updated_at?: GraphCacheResolver<WithTypename<Subscriber>, Record<string, never>, Scalars['DateTime'] | string>;
  };
  SubscriberChartRow?: {
    count?: GraphCacheResolver<WithTypename<SubscriberChartRow>, Record<string, never>, Scalars['Int'] | string>;
    date?: GraphCacheResolver<WithTypename<SubscriberChartRow>, Record<string, never>, Scalars['DateTime'] | string>;
  };
  SubscriberConnection?: {
    edges?: GraphCacheResolver<WithTypename<SubscriberConnection>, Record<string, never>, Array<WithTypename<SubscriberEdge> | string>>;
    pageInfo?: GraphCacheResolver<WithTypename<SubscriberConnection>, Record<string, never>, WithTypename<PageInfo> | string>;
    totalCount?: GraphCacheResolver<WithTypename<SubscriberConnection>, Record<string, never>, Scalars['Int'] | string>;
  };
  SubscriberEdge?: {
    cursor?: GraphCacheResolver<WithTypename<SubscriberEdge>, Record<string, never>, Scalars['String'] | string>;
    node?: GraphCacheResolver<WithTypename<SubscriberEdge>, Record<string, never>, WithTypename<Subscriber> | string>;
  };
  Template?: {
    cart_id?: GraphCacheResolver<WithTypename<Template>, Record<string, never>, Scalars['ID'] | string>;
    creator_id?: GraphCacheResolver<WithTypename<Template>, Record<string, never>, Scalars['ID'] | string>;
    id?: GraphCacheResolver<WithTypename<Template>, Record<string, never>, Scalars['ID'] | string>;
    media_url?: GraphCacheResolver<WithTypename<Template>, Record<string, never>, Scalars['AbsoluteUrl'] | string>;
    parameters?: GraphCacheResolver<WithTypename<Template>, Record<string, never>, Scalars['JSONObject'] | string>;
    template?: GraphCacheResolver<WithTypename<Template>, Record<string, never>, Scalars['String'] | string>;
    type?: GraphCacheResolver<WithTypename<Template>, Record<string, never>, TemplateType | string>;
  };
  TemplateConnection?: {
    edges?: GraphCacheResolver<WithTypename<TemplateConnection>, Record<string, never>, Array<WithTypename<TemplateEdge> | string>>;
    pageInfo?: GraphCacheResolver<WithTypename<TemplateConnection>, Record<string, never>, WithTypename<PageInfo> | string>;
    totalCount?: GraphCacheResolver<WithTypename<TemplateConnection>, Record<string, never>, Scalars['Int'] | string>;
  };
  TemplateDeleteOutput?: {
    success?: GraphCacheResolver<WithTypename<TemplateDeleteOutput>, Record<string, never>, Scalars['Boolean'] | string>;
  };
  TemplateEdge?: {
    cursor?: GraphCacheResolver<WithTypename<TemplateEdge>, Record<string, never>, Scalars['String'] | string>;
    node?: GraphCacheResolver<WithTypename<TemplateEdge>, Record<string, never>, WithTypename<Template> | string>;
  };
  UserAnonymized?: {
    id?: GraphCacheResolver<WithTypename<UserAnonymized>, Record<string, never>, Scalars['ID'] | string>;
    name?: GraphCacheResolver<WithTypename<UserAnonymized>, Record<string, never>, Scalars['String'] | string>;
  };
  UserAnonymizedConnection?: {
    edges?: GraphCacheResolver<
      WithTypename<UserAnonymizedConnection>,
      Record<string, never>,
      Array<WithTypename<UserAnonymizedEdge> | string>
    >;
    pageInfo?: GraphCacheResolver<WithTypename<UserAnonymizedConnection>, Record<string, never>, WithTypename<PageInfo> | string>;
    totalCount?: GraphCacheResolver<WithTypename<UserAnonymizedConnection>, Record<string, never>, Scalars['Int'] | string>;
  };
  UserAnonymizedEdge?: {
    cursor?: GraphCacheResolver<WithTypename<UserAnonymizedEdge>, Record<string, never>, Scalars['String'] | string>;
    node?: GraphCacheResolver<WithTypename<UserAnonymizedEdge>, Record<string, never>, WithTypename<UserAnonymized> | string>;
  };
  UserCurrent?: {
    brand?: GraphCacheResolver<WithTypename<UserCurrent>, Record<string, never>, Scalars['String'] | string>;
    creators?: GraphCacheResolver<WithTypename<UserCurrent>, Record<string, never>, Array<WithTypename<Creator> | string>>;
    email?: GraphCacheResolver<WithTypename<UserCurrent>, Record<string, never>, Scalars['EmailAddress'] | string>;
    id?: GraphCacheResolver<WithTypename<UserCurrent>, Record<string, never>, Scalars['ID'] | string>;
    is_superadmin?: GraphCacheResolver<WithTypename<UserCurrent>, Record<string, never>, Scalars['Boolean'] | string>;
    name?: GraphCacheResolver<WithTypename<UserCurrent>, Record<string, never>, Scalars['String'] | string>;
  };
  UserFull?: {
    brand?: GraphCacheResolver<WithTypename<UserFull>, Record<string, never>, Scalars['String'] | string>;
    email?: GraphCacheResolver<WithTypename<UserFull>, Record<string, never>, Scalars['EmailAddress'] | string>;
    id?: GraphCacheResolver<WithTypename<UserFull>, Record<string, never>, Scalars['ID'] | string>;
    is_approved?: GraphCacheResolver<WithTypename<UserFull>, Record<string, never>, Scalars['Boolean'] | string>;
    is_superadmin?: GraphCacheResolver<WithTypename<UserFull>, Record<string, never>, Scalars['Boolean'] | string>;
    name?: GraphCacheResolver<WithTypename<UserFull>, Record<string, never>, Scalars['String'] | string>;
    role?: GraphCacheResolver<WithTypename<UserFull>, Record<string, never>, Scalars['String'] | string>;
  };
  UserFullConnection?: {
    edges?: GraphCacheResolver<WithTypename<UserFullConnection>, Record<string, never>, Array<WithTypename<UserFullEdge> | string>>;
    pageInfo?: GraphCacheResolver<WithTypename<UserFullConnection>, Record<string, never>, WithTypename<PageInfo> | string>;
    totalCount?: GraphCacheResolver<WithTypename<UserFullConnection>, Record<string, never>, Scalars['Int'] | string>;
  };
  UserFullEdge?: {
    cursor?: GraphCacheResolver<WithTypename<UserFullEdge>, Record<string, never>, Scalars['String'] | string>;
    node?: GraphCacheResolver<WithTypename<UserFullEdge>, Record<string, never>, WithTypename<UserFull> | string>;
  };
  VideoUploadOutput?: {
    signed_url?: GraphCacheResolver<WithTypename<VideoUploadOutput>, Record<string, never>, Scalars['AbsoluteUrl'] | string>;
    url?: GraphCacheResolver<WithTypename<VideoUploadOutput>, Record<string, never>, Scalars['AbsoluteUrl'] | string>;
  };
};

export type GraphCacheOptimisticUpdaters = {
  BasketAddPaymentMethod?: GraphCacheOptimisticMutationResolver<MutationBasketAddPaymentMethodArgs, WithTypename<Basket>>;
  BasketCreate?: GraphCacheOptimisticMutationResolver<MutationBasketCreateArgs, WithTypename<Basket>>;
  BasketFinalize?: GraphCacheOptimisticMutationResolver<MutationBasketFinalizeArgs, Maybe<WithTypename<Basket>>>;
  BasketPrepareOrder?: GraphCacheOptimisticMutationResolver<MutationBasketPrepareOrderArgs, WithTypename<Basket>>;
  BasketUpdate?: GraphCacheOptimisticMutationResolver<MutationBasketUpdateArgs, WithTypename<Basket>>;
  CartRefresh?: GraphCacheOptimisticMutationResolver<MutationCartRefreshArgs, WithTypename<Cart>>;
  CartUpsert?: GraphCacheOptimisticMutationResolver<MutationCartUpsertArgs, WithTypename<Cart>>;
  ConversionTrack?: GraphCacheOptimisticMutationResolver<MutationConversionTrackArgs, WithTypename<LiteConversion>>;
  CreatorAcceptInvite?: GraphCacheOptimisticMutationResolver<MutationCreatorAcceptInviteArgs, WithTypename<Creator>>;
  CreatorApproveUserProfile?: GraphCacheOptimisticMutationResolver<MutationCreatorApproveUserProfileArgs, WithTypename<Creator>>;
  CreatorProfileUpsert?: GraphCacheOptimisticMutationResolver<MutationCreatorProfileUpsertArgs, WithTypename<Creator>>;
  ImageUpload?: GraphCacheOptimisticMutationResolver<MutationImageUploadArgs, WithTypename<ImageUploadOutput>>;
  LiteCampaignUpsert?: GraphCacheOptimisticMutationResolver<MutationLiteCampaignUpsertArgs, WithTypename<LiteCampaign>>;
  PhoneNumberReserve?: GraphCacheOptimisticMutationResolver<MutationPhoneNumberReserveArgs, WithTypename<Creator>>;
  ReservationAdd?: GraphCacheOptimisticMutationResolver<MutationReservationAddArgs, WithTypename<Reservation>>;
  ShopAddPaymentProvider?: GraphCacheOptimisticMutationResolver<
    MutationShopAddPaymentProviderArgs,
    | WithTypename<ShopBrand>
    | WithTypename<ShopNative>
    | WithTypename<ShopSfcc>
    | WithTypename<ShopShopify>
    | WithTypename<ShopShopifyNative>
  >;
  ShopCreateSFCC?: GraphCacheOptimisticMutationResolver<
    MutationShopCreateSfccArgs,
    | WithTypename<ShopBrand>
    | WithTypename<ShopNative>
    | WithTypename<ShopSfcc>
    | WithTypename<ShopShopify>
    | WithTypename<ShopShopifyNative>
  >;
  ShopCreateShopify?: GraphCacheOptimisticMutationResolver<MutationShopCreateShopifyArgs, WithTypename<ShopCreateShopifyOutput>>;
  ShopCreateShopifyNative?: GraphCacheOptimisticMutationResolver<
    MutationShopCreateShopifyNativeArgs,
    | WithTypename<ShopBrand>
    | WithTypename<ShopNative>
    | WithTypename<ShopSfcc>
    | WithTypename<ShopShopify>
    | WithTypename<ShopShopifyNative>
  >;
  ShopEdit?: GraphCacheOptimisticMutationResolver<
    MutationShopEditArgs,
    | WithTypename<ShopBrand>
    | WithTypename<ShopNative>
    | WithTypename<ShopSfcc>
    | WithTypename<ShopShopify>
    | WithTypename<ShopShopifyNative>
  >;
  ShopInviteCreator?: GraphCacheOptimisticMutationResolver<
    MutationShopInviteCreatorArgs,
    | WithTypename<ShopBrand>
    | WithTypename<ShopNative>
    | WithTypename<ShopSfcc>
    | WithTypename<ShopShopify>
    | WithTypename<ShopShopifyNative>
  >;
  ShopRemovePaymentProvider?: GraphCacheOptimisticMutationResolver<
    MutationShopRemovePaymentProviderArgs,
    | WithTypename<ShopBrand>
    | WithTypename<ShopNative>
    | WithTypename<ShopSfcc>
    | WithTypename<ShopShopify>
    | WithTypename<ShopShopifyNative>
  >;
  TemplateDelete?: GraphCacheOptimisticMutationResolver<MutationTemplateDeleteArgs, WithTypename<TemplateDeleteOutput>>;
  TemplateUpsert?: GraphCacheOptimisticMutationResolver<MutationTemplateUpsertArgs, WithTypename<Template>>;
  UserUpdate?: GraphCacheOptimisticMutationResolver<MutationUserUpdateArgs, WithTypename<UserFull>>;
  VideoUpload?: GraphCacheOptimisticMutationResolver<MutationVideoUploadArgs, WithTypename<VideoUploadOutput>>;
};

export type GraphCacheUpdaters = {
  Mutation?: {
    BasketAddPaymentMethod?: GraphCacheUpdateResolver<{ BasketAddPaymentMethod: WithTypename<Basket> }, MutationBasketAddPaymentMethodArgs>;
    BasketCreate?: GraphCacheUpdateResolver<{ BasketCreate: WithTypename<Basket> }, MutationBasketCreateArgs>;
    BasketFinalize?: GraphCacheUpdateResolver<{ BasketFinalize: Maybe<WithTypename<Basket>> }, MutationBasketFinalizeArgs>;
    BasketPrepareOrder?: GraphCacheUpdateResolver<{ BasketPrepareOrder: WithTypename<Basket> }, MutationBasketPrepareOrderArgs>;
    BasketUpdate?: GraphCacheUpdateResolver<{ BasketUpdate: WithTypename<Basket> }, MutationBasketUpdateArgs>;
    CartRefresh?: GraphCacheUpdateResolver<{ CartRefresh: WithTypename<Cart> }, MutationCartRefreshArgs>;
    CartUpsert?: GraphCacheUpdateResolver<{ CartUpsert: WithTypename<Cart> }, MutationCartUpsertArgs>;
    ConversionTrack?: GraphCacheUpdateResolver<{ ConversionTrack: WithTypename<LiteConversion> }, MutationConversionTrackArgs>;
    CreatorAcceptInvite?: GraphCacheUpdateResolver<{ CreatorAcceptInvite: WithTypename<Creator> }, MutationCreatorAcceptInviteArgs>;
    CreatorApproveUserProfile?: GraphCacheUpdateResolver<
      { CreatorApproveUserProfile: WithTypename<Creator> },
      MutationCreatorApproveUserProfileArgs
    >;
    CreatorProfileUpsert?: GraphCacheUpdateResolver<{ CreatorProfileUpsert: WithTypename<Creator> }, MutationCreatorProfileUpsertArgs>;
    ImageUpload?: GraphCacheUpdateResolver<{ ImageUpload: WithTypename<ImageUploadOutput> }, MutationImageUploadArgs>;
    LiteCampaignUpsert?: GraphCacheUpdateResolver<{ LiteCampaignUpsert: WithTypename<LiteCampaign> }, MutationLiteCampaignUpsertArgs>;
    PhoneNumberReserve?: GraphCacheUpdateResolver<{ PhoneNumberReserve: WithTypename<Creator> }, MutationPhoneNumberReserveArgs>;
    ReservationAdd?: GraphCacheUpdateResolver<{ ReservationAdd: WithTypename<Reservation> }, MutationReservationAddArgs>;
    ShopAddPaymentProvider?: GraphCacheUpdateResolver<
      {
        ShopAddPaymentProvider:
          | WithTypename<ShopBrand>
          | WithTypename<ShopNative>
          | WithTypename<ShopSfcc>
          | WithTypename<ShopShopify>
          | WithTypename<ShopShopifyNative>;
      },
      MutationShopAddPaymentProviderArgs
    >;
    ShopCreateSFCC?: GraphCacheUpdateResolver<
      {
        ShopCreateSFCC:
          | WithTypename<ShopBrand>
          | WithTypename<ShopNative>
          | WithTypename<ShopSfcc>
          | WithTypename<ShopShopify>
          | WithTypename<ShopShopifyNative>;
      },
      MutationShopCreateSfccArgs
    >;
    ShopCreateShopify?: GraphCacheUpdateResolver<
      { ShopCreateShopify: WithTypename<ShopCreateShopifyOutput> },
      MutationShopCreateShopifyArgs
    >;
    ShopCreateShopifyNative?: GraphCacheUpdateResolver<
      {
        ShopCreateShopifyNative:
          | WithTypename<ShopBrand>
          | WithTypename<ShopNative>
          | WithTypename<ShopSfcc>
          | WithTypename<ShopShopify>
          | WithTypename<ShopShopifyNative>;
      },
      MutationShopCreateShopifyNativeArgs
    >;
    ShopEdit?: GraphCacheUpdateResolver<
      {
        ShopEdit:
          | WithTypename<ShopBrand>
          | WithTypename<ShopNative>
          | WithTypename<ShopSfcc>
          | WithTypename<ShopShopify>
          | WithTypename<ShopShopifyNative>;
      },
      MutationShopEditArgs
    >;
    ShopInviteCreator?: GraphCacheUpdateResolver<
      {
        ShopInviteCreator:
          | WithTypename<ShopBrand>
          | WithTypename<ShopNative>
          | WithTypename<ShopSfcc>
          | WithTypename<ShopShopify>
          | WithTypename<ShopShopifyNative>;
      },
      MutationShopInviteCreatorArgs
    >;
    ShopRemovePaymentProvider?: GraphCacheUpdateResolver<
      {
        ShopRemovePaymentProvider:
          | WithTypename<ShopBrand>
          | WithTypename<ShopNative>
          | WithTypename<ShopSfcc>
          | WithTypename<ShopShopify>
          | WithTypename<ShopShopifyNative>;
      },
      MutationShopRemovePaymentProviderArgs
    >;
    TemplateDelete?: GraphCacheUpdateResolver<{ TemplateDelete: WithTypename<TemplateDeleteOutput> }, MutationTemplateDeleteArgs>;
    TemplateUpsert?: GraphCacheUpdateResolver<{ TemplateUpsert: WithTypename<Template> }, MutationTemplateUpsertArgs>;
    UserUpdate?: GraphCacheUpdateResolver<{ UserUpdate: WithTypename<UserFull> }, MutationUserUpdateArgs>;
    VideoUpload?: GraphCacheUpdateResolver<{ VideoUpload: WithTypename<VideoUploadOutput> }, MutationVideoUploadArgs>;
  };
  Subscription?: {};
};

export type GraphCacheConfig = {
  schema?: IntrospectionData;
  updates?: GraphCacheUpdaters;
  keys?: GraphCacheKeysConfig;
  optimistic?: GraphCacheOptimisticUpdaters;
  resolvers?: GraphCacheResolvers;
  storage?: GraphCacheStorageAdapter;
};
export const PriceFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment PriceFields on Price {
    currency
    amount
    old_amount
  }
`;
export const AddressFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment AddressFields on Address {
    city
    country
    line1
    line2
    postal_code
    state
  }
`;
export const AddressParentFieldsFragmentDoc = /*#__PURE__*/ gql`
  fragment AddressParentFields on AddressParent {
    name
    phone
  }
`;
export const BasketFragmentDoc = /*#__PURE__*/ gql`
  fragment Basket on Basket {
    id
    cart_id
    external_url
    items {
      sku
      quantity
      price {
        ...PriceFields
      }
    }
    subtotal {
      ...PriceFields
    }
    shipping_cost {
      ...PriceFields
    }
    taxes {
      name
      code
      price {
        ...PriceFields
      }
    }
    total {
      ...PriceFields
    }
    billing_address {
      address {
        ...AddressFields
      }
      ...AddressParentFields
    }
    shipping_address {
      address {
        ...AddressFields
      }
      ...AddressParentFields
    }
    payment_method {
      last_four_digits
      card_type
      full_name
      month
      year
    }
    transaction {
      state
    }
    order {
      id
    }
    shipping_method_id
    status
    email
    created_at
    updated_at
  }
`;
export const CartFragmentDoc = /*#__PURE__*/ gql`
  fragment Cart on Cart {
    id
    slug
    testimonial
    promo_message
    popup_discounts
    popup_timeout
    discount_code
    discount_message_template
    discount_applied_template
    tax_shipping_label
    requires_auth
    theme
    creator {
      id
      slug
      socials {
        handle
        type
        full_url
      }
      avatar
    }
    shop {
      avatar
      display_name
      default_currency
      default_country_code
    }
    items: products {
      id
      name
      description
      images {
        url
        alt
      }
      options {
        type
        value
        label
        choices {
          value
          label
          image {
            url
            alt
          }
        }
      }
      variants {
        id
        sku
        name
        description
        variations
        images {
          url
          alt
        }
        prices {
          currency
          amount
          old_amount
        }
        price(currency: "USD") {
          currency
          amount
          old_amount
        }
        soldOut
      }
    }
  }
`;
export const ConversionFragmentDoc = /*#__PURE__*/ gql`
  fragment Conversion on LiteConversion {
    campaign
    action
    ip
    userAgent
    referrer
    phoneNumber
  }
`;
export const BasketAddPaymentMethodDocument = /*#__PURE__*/ gql`
  mutation BasketAddPaymentMethod($input: BasketAddPaymentMethodInput!) {
    BasketAddPaymentMethod(input: $input) {
      ...Basket
    }
  }
  ${BasketFragmentDoc}
  ${PriceFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${AddressParentFieldsFragmentDoc}
`;

export function useBasketAddPaymentMethodMutation() {
  return Urql.useMutation<BasketAddPaymentMethodMutation, BasketAddPaymentMethodMutationVariables>(BasketAddPaymentMethodDocument);
}
export const BasketCreateDocument = /*#__PURE__*/ gql`
  mutation BasketCreate($input: BasketCreateInput!) {
    BasketCreate(input: $input) {
      ...Basket
    }
  }
  ${BasketFragmentDoc}
  ${PriceFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${AddressParentFieldsFragmentDoc}
`;

export function useBasketCreateMutation() {
  return Urql.useMutation<BasketCreateMutation, BasketCreateMutationVariables>(BasketCreateDocument);
}
export const BasketFinalizeDocument = /*#__PURE__*/ gql`
  mutation BasketFinalize($input: BasketFinalizeInput!) {
    BasketFinalize(input: $input) {
      ...Basket
    }
  }
  ${BasketFragmentDoc}
  ${PriceFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${AddressParentFieldsFragmentDoc}
`;

export function useBasketFinalizeMutation() {
  return Urql.useMutation<BasketFinalizeMutation, BasketFinalizeMutationVariables>(BasketFinalizeDocument);
}
export const BasketPrepareOrderDocument = /*#__PURE__*/ gql`
  mutation BasketPrepareOrder($input: BasketPrepareOrderInput!) {
    BasketPrepareOrder(input: $input) {
      ...Basket
    }
  }
  ${BasketFragmentDoc}
  ${PriceFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${AddressParentFieldsFragmentDoc}
`;

export function useBasketPrepareOrderMutation() {
  return Urql.useMutation<BasketPrepareOrderMutation, BasketPrepareOrderMutationVariables>(BasketPrepareOrderDocument);
}
export const BasketUpdateDocument = /*#__PURE__*/ gql`
  mutation BasketUpdate($input: BasketUpdateInput!) {
    BasketUpdate(input: $input) {
      ...Basket
    }
  }
  ${BasketFragmentDoc}
  ${PriceFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${AddressParentFieldsFragmentDoc}
`;

export function useBasketUpdateMutation() {
  return Urql.useMutation<BasketUpdateMutation, BasketUpdateMutationVariables>(BasketUpdateDocument);
}
export const ConversionTrackDocument = /*#__PURE__*/ gql`
  mutation ConversionTrack($input: ConversionInput!) {
    ConversionTrack(input: $input) {
      ...Conversion
    }
  }
  ${ConversionFragmentDoc}
`;

export function useConversionTrackMutation() {
  return Urql.useMutation<ConversionTrackMutation, ConversionTrackMutationVariables>(ConversionTrackDocument);
}
export const ReservationAddDocument = /*#__PURE__*/ gql`
  mutation ReservationAdd($input: ReservationAddInput!) {
    ReservationAdd(input: $input) {
      id
      phone_number
      slug
    }
  }
`;

export function useReservationAddMutation() {
  return Urql.useMutation<ReservationAddMutation, ReservationAddMutationVariables>(ReservationAddDocument);
}
export const BasketQueryDocument = /*#__PURE__*/ gql`
  query BasketQuery($creator_slug: String!, $slug: String!, $basketId: ID!) {
    Basket(id: $basketId) {
      ...Basket
    }
    Cart(creator_slug: $creator_slug, slug: $slug) {
      ...Cart
    }
    CartUserCurrent {
      id
      phone_number
    }
    BasketShippingMethods(id: $basketId) {
      id
      name
      price {
        currency
        amount
        old_amount
      }
      is_default
    }
  }
  ${BasketFragmentDoc}
  ${PriceFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${AddressParentFieldsFragmentDoc}
  ${CartFragmentDoc}
`;

export function useBasketQuery(options: Omit<Urql.UseQueryArgs<BasketQueryVariables>, 'query'>) {
  return Urql.useQuery<BasketQuery, BasketQueryVariables>({ query: BasketQueryDocument, ...options });
}
export const BasketShippingMethodsDocument = /*#__PURE__*/ gql`
  query BasketShippingMethods($id: ID!) {
    BasketShippingMethods(id: $id) {
      id
      name
      price {
        currency
        amount
        old_amount
      }
      is_default
    }
  }
`;

export function useBasketShippingMethodsQuery(options: Omit<Urql.UseQueryArgs<BasketShippingMethodsQueryVariables>, 'query'>) {
  return Urql.useQuery<BasketShippingMethodsQuery, BasketShippingMethodsQueryVariables>({
    query: BasketShippingMethodsDocument,
    ...options,
  });
}
export const CampaignSubscribeDocument = /*#__PURE__*/ gql`
  query CampaignSubscribe($creator_slug: String!, $slug: String!) {
    CampaignSubscribe(creator_slug: $creator_slug, slug: $slug) {
      campaign_id
      phone_number
      body
    }
  }
`;

export function useCampaignSubscribeQuery(options: Omit<Urql.UseQueryArgs<CampaignSubscribeQueryVariables>, 'query'>) {
  return Urql.useQuery<CampaignSubscribeQuery, CampaignSubscribeQueryVariables>({ query: CampaignSubscribeDocument, ...options });
}
export const CartQueryDocument = /*#__PURE__*/ gql`
  query CartQuery($creator_slug: String!, $slug: String!) {
    Cart(creator_slug: $creator_slug, slug: $slug) {
      ...Cart
    }
  }
  ${CartFragmentDoc}
`;

export function useCartQuery(options: Omit<Urql.UseQueryArgs<CartQueryVariables>, 'query'>) {
  return Urql.useQuery<CartQuery, CartQueryVariables>({ query: CartQueryDocument, ...options });
}
export const ShopifyCartQueryDocument = /*#__PURE__*/ gql`
  query ShopifyCartQuery($creator_slug: String!, $slug: String!) {
    Cart(creator_slug: $creator_slug, slug: $slug) {
      id
      slug
      testimonial
      promo_message
      popup_discounts
      popup_timeout
      discount_code
      discount_message_template
      discount_applied_template
      tax_shipping_label
      requires_auth
      theme
      creator {
        id
        slug
        socials {
          handle
          type
          full_url
        }
        avatar
      }
      shop {
        avatar
        display_name
        default_currency
        default_country_code
      }
    }
  }
`;

export function useShopifyCartQuery(options: Omit<Urql.UseQueryArgs<ShopifyCartQueryVariables>, 'query'>) {
  return Urql.useQuery<ShopifyCartQuery, ShopifyCartQueryVariables>({ query: ShopifyCartQueryDocument, ...options });
}
export const CartShopProviderDocument = /*#__PURE__*/ gql`
  query CartShopProvider($creator_slug: String!, $slug: String!) {
    Cart(creator_slug: $creator_slug, slug: $slug) {
      shop {
        provider
      }
    }
  }
`;

export function useCartShopProviderQuery(options: Omit<Urql.UseQueryArgs<CartShopProviderQueryVariables>, 'query'>) {
  return Urql.useQuery<CartShopProviderQuery, CartShopProviderQueryVariables>({ query: CartShopProviderDocument, ...options });
}
export const CartSubscribeDocument = /*#__PURE__*/ gql`
  query CartSubscribe($creator_slug: String!, $slug: String!) {
    CartSubscribe(creator_slug: $creator_slug, slug: $slug) {
      phone_number
      body
    }
  }
`;

export function useCartSubscribeQuery(options: Omit<Urql.UseQueryArgs<CartSubscribeQueryVariables>, 'query'>) {
  return Urql.useQuery<CartSubscribeQuery, CartSubscribeQueryVariables>({ query: CartSubscribeDocument, ...options });
}
export const GeolocationDocument = /*#__PURE__*/ gql`
  query Geolocation {
    Geolocation {
      country_code
      city
      calling_code
    }
  }
`;

export function useGeolocationQuery(options?: Omit<Urql.UseQueryArgs<GeolocationQueryVariables>, 'query'>) {
  return Urql.useQuery<GeolocationQuery, GeolocationQueryVariables>({ query: GeolocationDocument, ...options });
}
export const InvoiceQueryDocument = /*#__PURE__*/ gql`
  query InvoiceQuery($basket_id: ID!, $payment_intent_id: ID!) {
    Invoice(basket_id: $basket_id, payment_intent_id: $payment_intent_id) {
      basket {
        ...Basket
      }
      cart {
        ...Cart
      }
    }
  }
  ${BasketFragmentDoc}
  ${PriceFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${AddressParentFieldsFragmentDoc}
  ${CartFragmentDoc}
`;

export function useInvoiceQuery(options: Omit<Urql.UseQueryArgs<InvoiceQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoiceQuery, InvoiceQueryVariables>({ query: InvoiceQueryDocument, ...options });
}
export const LiteCampaignProductDocument = /*#__PURE__*/ gql`
  query LiteCampaignProduct($creator_slug: String!, $slug: String!) {
    LiteCampaignWithSlug(creator_slug: $creator_slug, slug: $slug) {
      id
      links {
        link
        slug
      }
    }
  }
`;

export function useLiteCampaignProductQuery(options: Omit<Urql.UseQueryArgs<LiteCampaignProductQueryVariables>, 'query'>) {
  return Urql.useQuery<LiteCampaignProductQuery, LiteCampaignProductQueryVariables>({ query: LiteCampaignProductDocument, ...options });
}
